import SvgIcon from '@mui/material/SvgIcon';

const OgWassie = () => {
  return (
    <SvgIcon sx={{ width: 150, height: 150}}>
      <svg
    xmlns="http://www.w3.org/2000/svg"
    data-name="Capa 1"
    viewBox="0 0 720 720"
  >
    <path
      d="M236.32 289.35c.25.99-.23 1.92-1.43 2.79-.25.19-.42.48-.45.79-.35 3.19-1.67 6.35-2.1 9.15-1.17 7.59-2.09 15.21-2.76 22.86-.15 1.7.43 3.74.12 5.25-3.67 18.41-7.34 36.83-10.99 55.25-1.43 7.19-2.51 13.76-3.25 19.73-4.07 32.66-5.61 63.26-2.39 95.75.83 8.38 2.7 19.21 5.46 25.83 2.79 6.71 5.16 14.37 8.45 20.1 2.15 3.74 4.61 7.27 7.38 10.6 4.22 5.06 5.33 10.68 5.07 17.51-.09 2.45.09 4.62.53 6.51 1.18 5.11 2.47 10.19 3.86 15.24 2.29 8.28 5.3 14.3 10.06 20.94 2.44 3.4 7.91 5.78 7.32 11.64-.03.31-.14.57-.35.8-4.01 4.43-10.11 5.25-15.38 7.06-2.54.87-5.79 2.31-9.75 4.31-7.01 3.54-14.34 5.61-21.41 8.89-2.32 1.07-4.63 2.1-6.92 3.09"
      style={{
        fill: "none",
        stroke: "#5d5462",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M207.39 653.44c-11.02 8.26 7.25 9.93 10.81 10.25 9.34.84 18.66 1.84 27.97 3 3.38.42 6 1.91 7.87 4.48"
      style={{
        fill: "none",
        stroke: "#695f6f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M254.04 671.17c-2.91 8.57-10.44 13.07-12.4 22.84-.21 1.06.7 2.01 1.77 1.83 1.41-.23 2.58.04 4.06-.4 11.29-3.41 18.88-5.3 22.78-5.68 4.98-.49 9.16 2.04 13.25 4.27.79.43 1.78.27 2.39-.4 11.56-12.68 26.83-22.58 41.16-31.87"
      style={{
        fill: "none",
        stroke: "#5d5462",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M327.05 661.76c2.61-1.61 5.29-3.07 8.04-4.37 8.83-4.18 11.7-9.13 16.79-16.9.76-1.16 2-1.91 3.39-2.05 4.79-.46 9.74-.77 14.85-.94 2.3-.07 4.26.66 6.52 1.12.32.06.52.37.44.69-.42 1.73-.41 3.37.04 4.9"
      style={{
        fill: "none",
        stroke: "#695f6f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M377.12 644.21c-.82 1.3-1.17 2.97-1.99 4.26-7.39 11.55-14.06 21.58-16.27 35.28-.5 3.1-2.93 10.45-.47 12.83.73.71 1.49.76 2.3.13 7.38-5.74 15.43-13.91 24.04-16.9a1.66 1.66 0 0 1 2.19 1.4c.75 7.79 2.06 14.84 3.94 21.16"
      style={{
        fill: "none",
        stroke: "#5d5462",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M390.86 702.37c1.42 1.25 2.79 2.14 4.12 2.67 3.9 1.58 11.58-3.58 14.7-5.8 3.77-2.68 7.53-4.13 11.48-6.13 2.85-1.44 5.5-.76 8.3.12.3.1.53.01.7-.26 1.99-3.22 3.69-6.59 5.08-10.1 2.08-5.25 2.75-11.33 3.58-17.12"
      style={{
        fill: "none",
        stroke: "#695f6f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M438.82 665.75c.62-3.21 1.25-5.98.89-9.35-.47-4.53-.8-9.07-.99-13.62-.01-.31.05-.61.2-.88 1.81-3.37 3.85-5.81 6.14-7.32 4.09-2.72 13.4-8.3 15.23-12.8 5.95-14.67 19.84-5.51 30.34-9.25 8.71-3.11 11.01-6.7 12.2-15.8.58-4.5-.99-7.95-4.72-10.35-8.05-5.18-16.2-10.19-24.45-15.02-3.06-1.79-5.58-3.77-7.56-5.93-.19-.21-.31-.47-.34-.76l-1.07-9.47c-.17-1.5.48-2.08 1.95-1.75 2.5.57 7.71 3.47 10.4 2.1.3-.15.46-.4.49-.74 1.42-20.09 1.12-40.13-.89-60.13-1.23-12.27-1.89-18.9-1.97-19.89-1.46-17.27-2.61-34.7-4.61-51.91-.35-2.99-.43-6.62-.22-10.89.17-3.5-1.35-7.14-1.32-10.77.11-13.05-.39-26.02-1.51-38.9"
      style={{
        fill: "none",
        stroke: "#5d5462",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M467.01 362.32c.31-7.48 0-14.91-.9-22.3-.62-5.03-.06-9.79-.91-14.81-.53-3.15.34-5.34-1.25-8.71"
      style={{
        fill: "none",
        stroke: "#7e7485",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M463.95 316.5c-.27-3.37-.68-6.73-1.23-10.09-2.01-12.23-3.82-24.75-3.84-37.16-.02-16.11-.06-32.23-.11-48.34-.03-11.45-1.5-22.23-2.86-33.48-1.73-14.34-5.58-28.06-7.41-42.39"
      style={{
        fill: "none",
        stroke: "#5d5462",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M448.5 145.04c.75-6.27.54-12.38-.62-18.32"
      style={{
        fill: "none",
        stroke: "#7e7485",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M447.88 126.72c-.82-11.53-2.54-22.89-5.15-34.06-1.65-7.08-4.46-14.94-6.76-22.39-4.09-13.3-15.18-33.5-28.52-39.34-13.96-6.12-31.13-12.2-46.46-12.51-7.84-.16-15.67-.51-23.49-1.06"
      style={{
        fill: "none",
        stroke: "#5d5462",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M337.5 17.36c-4.18-.03-8.36-.07-12.55-.12-4.26-.06-7.47-1.94-12.2-.01-1.7.69-3.45.72-5.17 1.42-2.11.85-3.34 1.33-3.69 1.44-5.59 1.67-10.76 3.96-15.52 6.87"
      style={{
        fill: "none",
        stroke: "#7e7485",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M288.37 26.96c-2.54 2.45-5.99 3.92-8.43 5.83-6.24 4.85-12.35 9.14-17.57 15.27"
      style={{
        fill: "none",
        stroke: "#5d5462",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M262.37 48.06c-9.38 5.06-14.47 13.29-17.39 23.47"
      style={{
        fill: "none",
        stroke: "#7e7485",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M244.98 71.53c-2.84 4.67-5.16 9.76-6.96 15.25-1.88 5.75-8.82 8.86-13.03 12.95-4.37 4.26-3.68 11.3 1.04 15.04 2.21 1.75 4.31 3.63 6.31 5.62.21.21.46.33.75.34.25 0 .43.13.54.36 1 2.08 1.41 3.82 1.26 6.27-.47 7.84-1.09 15.67-1.85 23.49-.11 1.09-.96 3.33-1.67 4.13-4.88 5.45-7.22 10.09-7.68 16.78-.37 5.35 1.75 8.45-1.26 13.96-3.63 6.67-8.38 12.84-14.98 16.76a37.287 37.287 0 0 0-4.86 3.42c-3.72 3.08-6.54 7.99-9.85 11.83-5.57 6.46-10.38 13.2-14.43 20.23-2.09 3.61-4.11 6.07-4.15 10.48-.05 5.65 3.92 9.07 7.99 12.66 1.56 1.37 3.09 2.16 4.58 2.39.33.05.5.25.51.58v.49"
      style={{
        fill: "none",
        stroke: "#5d5462",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m337.5 17.36-5.37.95c-.06.01-.11.04-.15.08-.15.16-.33.3-.55.42-.17.09-.36.15-.55.17-2.67.27-5.33.19-7.96-.23-4.21-.68-11.41-.37-15.22 1.53-4.56 2.29-9.17 3.16-13.94 5.18-1.75.75-3.54 1.25-5.39 1.5M240.24 271.68l-.78 4.08c-.05.29 0 .55.17.78l3.44 4.82"
      style={{
        fill: "none",
        stroke: "#3b2e43",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M243.07 281.36a545.59 545.59 0 0 0-4.05 29.88c-.32 2.97-1.27 5.91-1.9 8.91-1.37 6.5-.57 14.22-.74 20.92-.07 2.74.39 6.1 1.37 10.07.07.32.05.63-.06.94-.41 1.11-.39 2.18.08 3.21.11.24.29.35.55.32l1.31-.13c.45-.05.81.36.7.8-.34 1.35 0 2.39 1.03 3.11.31.22.48.52.52.9l.62 6.78"
      style={{
        fill: "none",
        stroke: "#26182d",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M245.45 531.61c-1.74.46-2.4-.37-1.99-2.49.57-2.93-.42-6.57-.74-9.56-.03-.25-.16-.33-.39-.24-.09.03-.18.1-.25.19-.34.44.15 6.63-.89 8.83-1.62 3.41.46 12.78 1.35 16.81 1 4.49.96 9.1 2.14 13.47.57 2.09 1.07 4.21 1.52 6.35.07.33.03.65-.12.95-.97 1.88-.08 3.58 0 5.04.14 2.66.3 11.09 1.71 13.03.19.26.26.55.23.86-.39 3.3 1.28 5.05 2.32 7.41 1.19 2.71 2.75 5.04 4.68 6.99.73.74 1.31 1.42 1.72 2.05.18.27.41.48.7.63l4.58 2.33"
      style={{
        fill: "none",
        stroke: "#3b2e43",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M262.02 604.26c1.55 2.7 2.61 4.94 2.66 8.29.06 4.12-.19 13.72 5.72 14.31.33.03.65-.04.93-.2 2.29-1.37 4.77-1.91 7.42-1.64.28.03.57-.04.81-.21.76-.53 1.58-.75 2.47-.68.36.03.54.23.54.59-.01 1.35-.53 2.42-1.56 3.19-.29.21-.47.5-.55.85l-1.68 7.79c-.06.3-.2.56-.43.78-.87.85-1.8 1.35-2.79 1.5"
      style={{
        fill: "none",
        stroke: "#26182d",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M275.56 638.83c-3.5-1.8-6.6-3.99-9.31-6.56-.25-.24-.52-.28-.81-.11l-1.21.69"
      style={{
        fill: "none",
        stroke: "#5d4a63",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M264.23 632.85a66.974 66.974 0 0 1-13.12 5.39"
      style={{
        fill: "none",
        stroke: "#3b2e43",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M251.11 638.24c-7.19 2.08-13.52 5.64-19 10.67-.24.22-.37.53-.37.86-.01 4.65-5.39 6.56-9.18 6.15-.78-.09-1.12.95-.44 1.35l3.54 2.06c.29.17.6.26.93.28 10.61.59 23.01-.48 31.28 6.7.37.33.56.24.57-.25.01-1.3.34-2.47.97-3.5.29-.47.62-.67.98-.59.37.08.73.38 1.1.9"
      style={{
        fill: "none",
        stroke: "#26182d",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M261.49 662.87a29.85 29.85 0 0 1-1.77 9.55"
      style={{
        fill: "none",
        stroke: "#8d8690",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m259.72 672.42-2.83 3.96c-.2.28-.31.59-.33.94a15.18 15.18 0 0 1-2.15 6.8c-.17.29-.42.47-.75.54-1.58.37-2.37 2.97-3.25 4.18-.37.51.13 1.2.73.99 3.58-1.24 6.91-.87 9.93-1.7 7.72-2.14 13.36-4.62 20.58.5"
      style={{
        fill: "none",
        stroke: "#5d4a63",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m281.65 688.63.5.18c.29.1.52.03.7-.22 3.15-4.27 3.43-6.87 9.13-8.47.3-.09.57-.24.8-.46 1.47-1.38 3.86-3.2 7.17-5.46 3.15-2.16 6.94-7.82 11.12-9.73 3.75-1.71 7.14-3.94 10.18-6.69 1.18-1.07 1.8-2.86 4.02-3.4.32-.08.59-.23.81-.46 2.02-2.07 4.32-2.33 6.3-4.52 1.03-1.14 2-1.98 2.89-2.53 5.35-3.32 9.59-8.5 15.58-11.18.29-.13.58-.14.87-.05l2.2.69c.54.17.59.9.09 1.15-3.49 1.69-6.14 3.26-8.1 6.91-4.07 7.57-11.13 10.23-17.99 14.08-.28.16-.48.44-.52.75l-.35 2.54M254.04 671.17c1.13-1.38 1.48-2.96 1.03-4.75a.666.666 0 0 0-.81-.48c-1.37.33-2.52.06-3.46-.81-.27-.25-.6-.41-.97-.47a243.273 243.273 0 0 0-32.33-3.08c-1.17-.03-2.28-.37-3.31-1-.28-.17-.62-.22-.94-.16-2.01.43-3.89.13-5.65-.92-.35-.21-.49-.52-.4-.93l.72-3.39c.06-.27.03-.54-.08-.79l-.45-.95"
      style={{
        fill: "none",
        stroke: "#26182d",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M397.45 621.73c-.25.74-.12 1.21.38 1.41 4.17 1.7 14.16.31 18.93.05M419.44 642.02c-4.97.73-10.14.79-15.5.2-.32-.03-.6-.16-.83-.38-3.27-3.02-7.62-1.11-11.55-3.57-.28-.17-.58-.26-.91-.26l-3.96-.05"
      style={{
        fill: "none",
        stroke: "#695f6f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M281.65 688.63c.87-.27 1.23-.79 1.1-1.56-.05-.31-.03-.62.06-.93.5-1.69 1.28-3.23 2.34-4.62 1.08-1.41 2.85-1.83 4.2-3.21.25-.25.55-.39.9-.42 2.07-.16 3.38-1.41 3.91-3.75"
      style={{
        fill: "none",
        stroke: "#68556f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M294.16 674.14c5.57-6.7 13.53-12.71 20.37-18.1 6.7-5.27 14.68-9.71 22.21-14.33 1.01-.62 2.13-.92 3.22-1.52"
      style={{
        fill: "none",
        stroke: "#98919c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M339.96 640.19c.55.02 1.09-.09 1.62-.33.32-.15.46-.4.41-.75l-.04-.31c-.03-.24.06-.41.29-.52l3.48-1.55c.17-.07.16-.12-.02-.14-10.45-1.22-20.36-.51-29.75 2.12"
      style={{
        fill: "none",
        stroke: "#695f6f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M315.95 638.71c-5.02 2.91-9.02 4.57-11.99 5-3.94.57-10.04.59-18.31.08-3.82-.23-6.55-2.12-9.61-4.08"
      style={{
        fill: "none",
        stroke: "#98919c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M276.04 639.71c-.07-.29-.23-.59-.48-.88"
      style={{
        fill: "none",
        stroke: "#68556f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M447.88 126.72c-.87 6.43-.67 12.54.62 18.32M463.95 316.5c-.89 11.17-.44 23.4 1.36 36.69.61 4.45 1.17 7.5 1.7 9.13"
      style={{
        fill: "none",
        stroke: "#3b2e43",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M438.82 665.75c-1.67 2.47-2.63 5.1-2.9 7.87-.45 4.7-2.31 8.63-3.81 12.97-.11.33-.31.6-.59.8-1.87 1.32-3.92 2.03-6.17 2.14-4.16.21-6.59 1.69-10.04 3.77-1.41.85-3.15.93-4.5 2.02-2.94 2.37-6.09 5.52-9.68 6.77-1.49.51-3.01.97-4.57 1.37-.3.08-.62.04-.9-.1-1.29-.65-2.89-.98-4.8-.99M377.12 644.21c1.14-1.18 1.63-2.92 1.48-5.21a.913.913 0 0 0-.47-.75l-3.02-1.73a.846.846 0 0 1 .16-1.54l9.67-3.16c.23-.07.48.02.62.22l2.69 4.05c.23.36.18.66-.17.9l-1.39.97"
      style={{
        fill: "none",
        stroke: "#26182d",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M386.69 637.96c-.35.33-.66.74-.95 1.21-5.66 9.49-12.27 17.44-16.48 27.85-.13.31-.18.64-.17.97.03 1.07-.38 2.16-1.25 3.27-2.06 2.62-3.09 5.88-3.1 9.78 0 .34.12.39.36.15 5.71-5.65 11.02-11.36 17.98-15.76"
      style={{
        fill: "none",
        stroke: "#5d5462",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M383.08 665.43c2.1-1.07 8.33-2.72 9.38.84 1.56 5.32 1.32 9.97 1.88 15.11"
      style={{
        fill: "none",
        stroke: "#8d8690",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M394.34 681.38c-.29 3.76.17 11.41 5.54 8.93.29-.13.6-.19.91-.18 4.07.19 8.52-3.92 11.39-6.87.23-.24.52-.41.83-.5 2.3-.67 4.07-2.03 6.34-2.71 1.5-.45 2.06-1.2 1.68-2.26"
      style={{
        fill: "none",
        stroke: "#3b2e43",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M421.03 677.79c3.21-1.12 5.93-1.66 8.17-1.62 1.42.03 2.39-.62 2.91-1.93 3.97-9.98.29-22.24-2.27-32.14"
      style={{
        fill: "none",
        stroke: "#8d8690",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M429.84 642.1c.13-.33.08-1.1-.17-2.3a.756.756 0 0 0-.96-.58l-9.27 2.8"
      style={{
        fill: "none",
        stroke: "#5d5462",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M419.44 642.02c-.43-.32-.7-.61-.81-.86-.1-.24-.28-.34-.53-.31-.8.11-1.24-.26-1.32-1.12-.25-2.69 1.33-6.14 1.45-8.68.11-2.48-.25-4.9-1.08-7.27-.1-.28-.49-.28-.58 0l-.11.35c-.08.23-.22.28-.42.16l-.34-.2c-.24-.15-.22-.25.05-.3.45-.09.79-.29 1.01-.6"
      style={{
        fill: "none",
        stroke: "#26182d",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M416.76 623.19c2.6-.22 5.17-.93 7.72-2.13"
      style={{
        fill: "none",
        stroke: "#5d5462",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M424.48 621.06c3.13-1.13 6.35-1.35 9.67-.66.35.07.65.28.85.57 2.49 3.81 2.72 9.97 3.19 14.56.09.87 1.11 1.28 1.78.73l5.95-4.87c.89-.73 2.11-1.84 3.53-3.22 5.51-5.36 5.91-6.45 6.33-14.44.17-3.22 1.56-5.27 4.17-6.16 1.17-.4 3.38-.51 6.61-.32 8.88.5 17.73 1.79 26.81.11 3.54-.65 4.96-3.27 4.11-6.6-.08-.3 0-.62.24-.84.7-.66.83-1.38.39-2.15-.16-.29-.23-.61-.22-.94.1-2.81-.65-5.34-2.24-7.59-1.15-1.63-2.83-1.92-4.49-3.02-.27-.18-.46-.43-.56-.74-.66-2.03-1.83-1.97-3.29-2.82a335.88 335.88 0 0 0-6.9-3.87c-.27-.14-.45-.36-.55-.65-.19-.55-.66-.92-1.39-1.11-3.15-.81-6.03-2.53-8.64-5.15a1.05 1.05 0 0 0-.84-.32c-2.47.13-4.95-.59-7.42-2.16"
      style={{
        fill: "none",
        stroke: "#26182d",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m461.57 569.4-1.51-10.18"
      style={{
        fill: "none",
        stroke: "#5d5462",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m460.06 559.22-.3-6.95"
      style={{
        fill: "none",
        stroke: "#8d8690",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M459.76 552.27c.45-.29.61-.79.49-1.5-.28-1.59.22-2.97 1.98-3.2 1.21-.16 2.46.76 3.42 1.46"
      style={{
        fill: "none",
        stroke: "#26182d",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m465.65 549.03 8.18 3.9c.41.19.62.06.64-.39.09-1.89.05-4.42-.13-7.61-.37-6.73-1.15-12.58-2.34-17.57"
      style={{
        fill: "none",
        stroke: "#3b2e43",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M472 527.36c-.29-5.35-1.8-10.93-1.89-15.85-.1-5-.02-10 .25-15.01.11-2.09-.85-5.2-.88-7.69-.27-22.48-1.04-43.28-4.57-65.02"
      style={{
        fill: "none",
        stroke: "#5d4a63",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M464.91 423.79c.13-5.9-.35-11.7-.35-17.56 0-2.67-.83-5.8-.93-7.83-.49-9.77.63-19.49-.08-29.16-.25-3.5-.44-7.01-.55-10.52a.756.756 0 0 0-.75-.72h-3.78c-.63 0-1.17-.44-1.3-1.06-1.55-7.49-2.45-15.09-2.68-22.79"
      style={{
        fill: "none",
        stroke: "#26182d",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M454.49 334.15c1.67-2.18 2.01-4.34 1.04-6.48a.746.746 0 0 0-.79-.43c-.89.14-1.61-.13-2.18-.8-.24-.29-.36-.61-.36-.98-.05-13.13-.12-26.25-.21-39.37v-.01a1.73 1.73 0 0 0-.27-.08.34.34 0 0 1-.27-.33c-.11-10.19-.78-20.7-.2-30.91.02-.35-.2-.74-.65-1.15a1.25 1.25 0 0 1-.41-.84l-1.44-18.17"
      style={{
        fill: "none",
        stroke: "#5d4a63",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M448.74 234.6c.43-3.42.52-6.79.26-10.11-.26-3.36 2.58-8.22 2.54-12.61-.08-7.59-1.45-15.71-1.72-22.53-.17-4.37-.38-8.69-.61-12.94a3.102 3.102 0 0 0-2.92-2.93c-.45-.03-.85-.63-1.19-1.81-1.56-5.37-2.85-11-3.86-16.89"
      style={{
        fill: "none",
        stroke: "#26182d",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M441.24 154.78c.12-8.67-.71-17.25-2.48-25.76"
      style={{
        fill: "none",
        stroke: "#3b2e43",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M438.76 129.02c-1.74-20.23-5.69-39.94-11.84-59.15-3.89-12.14-10.87-20.47-19.65-28.15-9.03-7.89-21.05-11.74-32.48-14.59-.33-.08-.6 0-.83.25-2.51 2.78-5.09 3.71-9.04 3.09-16.92-2.66-33.92-2.65-50.98-2.82-.33-.01-.63.07-.9.23-4.47 2.55-10.09 5.41-16.84 8.57-8.75 4.09-17 9.25-24.73 15.47"
      style={{
        fill: "none",
        stroke: "#5d4a63",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M271.47 51.92c-3.11 2.07-5.86 4.64-8.25 7.7"
      style={{
        fill: "none",
        stroke: "#8d8690",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m263.22 59.62-4.56 5.13"
      style={{
        fill: "none",
        stroke: "#5d4a63",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M258.66 64.75c-5.03 4.16-8.05 11.04-10.86 16.79-1.12 2.29-1.91 4.77-2.38 7.42-.08.43.1.62.53.57l5.15-.57"
      style={{
        fill: "none",
        stroke: "#26182d",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M251.1 88.96c.69.37 1.58.47 2.65.29 8.17-1.37 15.75-.15 22.76 3.66"
      style={{
        fill: "none",
        stroke: "#5d4a63",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m276.51 92.91 2.57 2.53"
      style={{
        fill: "none",
        stroke: "#8d8690",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M279.08 95.44c4.99 4 2.11 11.37-3.12 13.74-.29.13-.54.35-.7.62-.99 1.68-1.44 3.93-2.33 5.32-4.89 7.59-14.18 9.34-23.07 11.22-.36.07-.67-.02-.92-.28l-.42-.42a.854.854 0 0 0-.79-.23c-1.8.39-3.48.2-5.03-.56a.68.68 0 0 0-.98.6l-.39 23"
      style={{
        fill: "none",
        stroke: "#5d4a63",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M241.33 148.45c-1.18 3.76.92 5.06 2 7.81.87 2.22 1.44 4.89 1.71 8.01.03.33.39.53.69.38 1.38-.69 1.97-1.56 1.77-2.59"
      style={{
        fill: "none",
        stroke: "#26182d",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M247.5 162.06c2.55-2.31 4.46-4.87 5.73-7.66"
      style={{
        fill: "none",
        stroke: "#5d4a63",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M253.23 154.4c-1.03-.15-1.83-.42-2.39-.81-.3-.21-.43-.49-.38-.86.27-2.12 1.14-4.32 2.61-6.59"
      style={{
        fill: "none",
        stroke: "#26182d",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M253.07 146.14c8.01-6.37 16.45-12.25 25.32-17.65 5.91-3.6 16.29-2.62 23.05-2.62 12.69 0 14.33 7.57 23.11 13.5 7.9 5.33 15.48 11.44 23.25 16.41 11.54 7.36 25.2 14.02 17.71 29.97-1.01 2.14-2.87 3.96-5.59 5.45"
      style={{
        fill: "none",
        stroke: "#5d4a63",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m359.92 191.2-2.35.97"
      style={{
        fill: "none",
        stroke: "#26182d",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M357.57 192.17c-.94.05-1.54.31-1.81.79"
      style={{
        fill: "none",
        stroke: "#5d5462",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M355.76 192.96c-2.28.99-3.56 2.25-3.84 3.77-1.33 7.28-3.4 11.73-7.95 18.52-2.81 4.2-5.12 8.66-6.95 13.37-4.53 11.7-10.08 19.79-20.05 27.84-4.41 3.56-4.31 7.64-10.55 9.4-8.2 2.31-16.49 4.49-24.87 6.52M279.15 272.92l-7.98 1.16"
      style={{
        fill: "none",
        stroke: "#8d8690",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M271.17 274.08a4.8 4.8 0 0 1-.12-2.2c.07-.42-.43-.68-.74-.39-2.86 2.7-6.12 3.66-9.77 2.89-4.36-.92-8.37-.74-12.69-1.92"
      style={{
        fill: "none",
        stroke: "#3b2e43",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M247.85 272.46c2.95-1.16 4.92-1.74 5.9-1.74 6.79 0 13.24.19 10.78-8.92"
      style={{
        fill: "none",
        stroke: "#0e0811",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m264.53 261.8 6.46-.61"
      style={{
        fill: "none",
        stroke: "#8d8690",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M270.99 261.19c-.53.13-.62.63-.27 1.48.12.29.04.62-.21.81-1.51 1.18-5.31 2.59-2.51 5.17.25.23.54.34.88.35 4.6.04 10.21-2.63 14.83-3.74 1.91-.46 3.18-1.33 1.93-3.44-.17-.27-.41-.42-.73-.43l-5.67-.18"
      style={{
        fill: "none",
        stroke: "#0e0811",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M279.24 261.21c-2.19-.77-4.33-1.01-6.43-.71"
      style={{
        fill: "none",
        stroke: "#5d4a63",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m272.81 260.5-13.78-2.85"
      style={{
        fill: "none",
        stroke: "#8d8690",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M259.03 257.65a.806.806 0 0 1-.25-.3.566.566 0 0 0-.45-.32c-2.09-.33-5.77-1.17-11.06-2.54-2.22-.57-3.95-.04-5.2 1.6"
      style={{
        fill: "none",
        stroke: "#26182d",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M242.07 256.09c-12.72-.34-25.38-.3-37.97.11-.74.03-1.54.43-2.25.61-.65.17-.59 1.11.08 1.2l3.77.48"
      style={{
        fill: "none",
        stroke: "#8d8690",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M205.7 258.49c-.4 1.08-.71 1.69-.93 1.83-1.5.94-1.17 3.21.54 3.69 1.12.31 1.44 1.13.97 2.46"
      style={{
        fill: "none",
        stroke: "#0e0811",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M244.98 71.53c4.77-8.75 10.56-16.57 17.39-23.47"
      style={{
        fill: "none",
        stroke: "#3b2e43",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M245.61 330.56c-2.25 6.53-2.99 12.71-2.22 18.53"
      style={{
        fill: "none",
        stroke: "#695f6f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m243.39 349.09-.33 7.69"
      style={{
        fill: "none",
        stroke: "#68556f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m243.06 356.78.07 4.47"
      style={{
        fill: "none",
        stroke: "#695f6f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M294.16 674.14c-1.84 1.26-4.94.53-7.2.94-6.09 1.09-13.01 1.45-18.22 2.57-3.39.73-6.78 1.68-10.18 2.84-.75.25-1.41-.56-1-1.24 1.25-2.03 1.97-4.31 2.16-6.83"
      style={{
        fill: "none",
        stroke: "#cfc3d2",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M261.55 661.48c.19-.49.61-.89 1.26-1.22.39-.2.39-.4 0-.61-.35-.18-.78-.22-1.27-.13"
      style={{
        fill: "none",
        stroke: "#d0cdd2",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M273.62 611.99c-4.62-.67-7.81-5.45-11.6-7.73"
      style={{
        fill: "none",
        stroke: "#47394f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M235.4 651.57c9.45-.12 17.96 2.13 25.54 6.74.29.18.49.58.6 1.21"
      style={{
        fill: "none",
        stroke: "#98919c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M261.54 659.52v1.96"
      style={{
        fill: "none",
        stroke: "#695f6f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m261.55 661.48-.06 1.39"
      style={{
        fill: "none",
        stroke: "#98919c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m247.85 272.46-7.61-.78"
      style={{
        fill: "none",
        stroke: "#2f2834",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m240.24 271.68-1.8-.12"
      style={{
        fill: "none",
        stroke: "#0e0811",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M238.44 271.56c-1.22-.7-2.25-1-3.09-.89"
      style={{
        fill: "none",
        stroke: "#2f2834",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M235.35 270.67c-5.67-2.31-11.25-3.32-16.76-3.04"
      style={{
        fill: "none",
        stroke: "#514e53",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M235.27 651.32c-.52-4.92 3.19-4.82 5.9-6.51 3.35-2.08 6.39-4.66 9.94-6.57"
      style={{
        fill: "none",
        stroke: "#47394f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M238.44 271.56c.18 3.07-.28 6.14-1.39 9.21"
      style={{
        fill: "none",
        stroke: "#3b2e43",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m454.62 541.62 4.37 5.32M460.06 559.22l-.03 9.71c0 .1.03.21.08.29l2.86 4.59c.15.25.37.41.65.48 3.33.86 6.22 2.39 8.68 4.59 4.96 4.44 10.08 7.83 15.61 11.48 3.65 2.42 5.38 4.8 4.8 9.1"
      style={{
        fill: "none",
        stroke: "#d0cdd2",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M492.71 599.46c-3.32 6.62-9.99 4.65-16.08 4.98-2.06.11-4.16-.64-6.42-.82"
      style={{
        fill: "none",
        stroke: "#cfc3d2",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M470.21 603.62c-6.03.17-12.16 1.07-18.37 2.7-4.28 1.12-7.58 3.81-11.09 6.4-12.4 9.17-25.29 7.72-40.25 8.58"
      style={{
        fill: "none",
        stroke: "#98919c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M400.5 621.3a5.94 5.94 0 0 0-3.05.43"
      style={{
        fill: "none",
        stroke: "#d0cdd2",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M397.45 621.73c-2.63.38-5.23.23-7.82-.45-5.42-1.42-10.95-1.19-16.49-1.59-1.79-.13-3.59-1.36-5.4-1.44-6.89-.31-13.78-.77-20.65-.75-16.12.06-32.61-.83-48.66.45-10 .8-16.94.25-24.81-5.96"
      style={{
        fill: "none",
        stroke: "#98919c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M273.62 611.99c-8.85-6.44-17.6-15.07-21.07-25.51-2.19-6.6-3.83-13.33-4.9-20.2-.51-3.28-1.89-6.52-2.46-9.95-1.05-6.33-2-10.77-.14-16.24 1.02-3.02.4-5.49.4-8.48"
      style={{
        fill: "none",
        stroke: "#aea7b2",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M245.45 531.61c.36-10.72-1.37-21.52-1.46-31.45-.34-35.8-.4-63.67-.19-83.6.13-11.92 4.22-22.4 1.16-33.55-1.46-5.28-1.65-10.68-2.46-15.94"
      style={{
        fill: "none",
        stroke: "#8d8690",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M242.5 367.07c.66-2.13.87-4.07.63-5.82"
      style={{
        fill: "none",
        stroke: "#98919c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M243.13 361.25c1.3-7.38.59-12.89 1.31-19.47.27-2.43 1.06-5.72 2.38-9.89 3.22-10.21 4.58-21.22 7.56-30.74 1.44-4.58 2.98-9.15 4.62-13.72"
      style={{
        fill: "none",
        stroke: "#d0cdd2",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M259 287.43c3.85-4.96 8.72-7.44 12.17-13.35"
      style={{
        fill: "none",
        stroke: "#aea7b2",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M259 287.43c-2.51 2.99-4.07 6.42-4.68 10.29-.76 4.78-4.08 8.49-5.25 13.36a165.76 165.76 0 0 0-3.46 19.48"
      style={{
        fill: "none",
        stroke: "#7e7485",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M245.61 330.56c-.26-4.99-.81-11.8 1.53-16.33.29-.55-.25-1.17-.84-.97l-1.46.5c-.74.26-1.5-.36-1.39-1.14.75-5.37 2.42-10.41 5.03-15.12a.81.81 0 0 0-.83-1.19l-1.51.23c-.5.07-.77-.14-.8-.64l-1.12-14.22c-.02-.31-.18-.45-.49-.42-.2.02-.42.05-.66.1"
      style={{
        fill: "none",
        stroke: "#47394f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M276.04 639.71c-10.79 2.52-21.09 6.24-31.83 8.73-2.87.67-5.81 1.72-8.81 3.13"
      style={{
        fill: "none",
        stroke: "#cfc3d2",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M235.4 651.57c.75-.32.7-.4-.13-.25"
      style={{
        fill: "none",
        stroke: "#68556f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M235.27 651.32c1.17-2.2 2.91-3.75 5.31-4 .44-.05.77-.25 1-.6.17-.27.4-.45.7-.56.99-.34 2.04-.29 2.93-.73 4.61-2.33 9.46-3.95 14.55-4.86 1.37-.24 3.07-1.58 5.09-4.02.21-.25.25-.52.1-.81-.51-1.05-.75-2.01-.72-2.89"
      style={{
        fill: "none",
        stroke: "#7e6b85",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M339.96 640.19c.39-.33.37-.64-.05-.91a.535.535 0 0 0-.37-.08c-7.73 1.03-15.6.87-23.59-.49M429.84 642.1c-5.23 2.75-10.38 3.4-15.47 1.96a.996.996 0 0 1-.65-.55c-.13-.27-.38-.41-.73-.44-3.68-.21-6.41-.13-10.22.96-5.36 1.53-10.86 2.07-16.49 1.63-.34-.03-.66.05-.95.23-2.77 1.7-4.61 4.09-5.52 7.16-.62 2.06-1.51 3.41-2.27 5.28-.11.27-.31.46-.59.57-.65.25-.88.69-.7 1.32.11.4 0 .72-.33.96-2.2 1.57-3.4 3.74-3.61 6.52-.03.35-.16.65-.39.91a28.617 28.617 0 0 0-5.18 8.16c-.28.66.57 1.21 1.06.69 4.7-5.01 7.9-8.92 15.28-12.03M251.95 257.66l5.53.27"
      style={{
        fill: "none",
        stroke: "#d0cdd2",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M272.81 260.5c-.21.2-.32.41-.34.63"
      style={{
        fill: "none",
        stroke: "#cfc3d2",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M272.47 261.13c-.58-.25-1.07-.23-1.48.06M264.53 261.8c-4.25-.98-8.89-.79-12.67-1.29a94.56 94.56 0 0 0-10.49-.79c-2.22-.04-4.93.96-7.42.64-9.31-1.19-18.83-1.13-28.25-1.87"
      style={{
        fill: "none",
        stroke: "#818181",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M421.03 677.79c-6.5 3.08-12.93 6.9-19.3 11.45-.33.23-.69.33-1.09.3l-3.21-.25c-.4-.03-.74-.3-.86-.68l-2.23-7.23"
      style={{
        fill: "none",
        stroke: "#aea7b2",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M424.48 621.06c-8.06 1.03-15.98 1.28-23.76.74-.15-.01-.23-.1-.22-.25.01-.09.01-.17 0-.25"
      style={{
        fill: "none",
        stroke: "#695f6f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M470.21 603.62c2.9 1.61 6.87.33 8.63 1.68.27.2.56.31.89.33 1.37.06 2.73-.04 4.07-.29 4.13-.79 7.34.02 9.59-4.91.16-.35.08-.66-.24-.95"
      style={{
        fill: "none",
        stroke: "#68556f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M441.24 154.78c-.08.08-.16.16-.23.24M364.98 195.63c2.69 3.75 5.6 7.14 8.73 10.16 10.49 10.14 16.37 24.01 20.22 37.83 2.27 8.13 5.05 14.75 7.85 22.18M414.08 450.2c-.49 4.49.34 9.01 2.48 13.58 4.64 9.9 8.31 17.44 11.02 22.61.08.17.22.31.4.4 1.19.61 1.69 1.6 1.5 2.97-.05.39.06.73.33 1.01 7.38 7.55 12 12.74 13.86 15.56 2.37 3.61 4.07 6.01 5.1 7.18.16.18.28.41.33.65 1.04 4.94 5.86 9.53 8.83 13.51.18.24.41.42.69.53 2.49 1.01 6.65 7.46 8.16 9.85.15.25.37.42.64.53 2.35.88.78 4.82-.43 5.99-.24.23-.4.51-.47.84l-.87 3.62"
      style={{
        fill: "none",
        stroke: "#47394f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m459.76 552.27-.77-5.33"
      style={{
        fill: "none",
        stroke: "#98919c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M458.99 546.94c0-2.41-1.47-4.18-4.37-5.32"
      style={{
        fill: "none",
        stroke: "#695f6f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M454.62 541.62a201.66 201.66 0 0 0-13.08-13.74c-3.23-3.09-5.6-6.69-8.31-10.18-7.03-9.05-13.48-21.41-17.33-30.13-2.31-5.23-3.78-9.09-4.41-11.57-7.82-30.75-11.12-61.79-14.48-93.25-.98-9.15-1.22-22.17-.72-39.07.49-16.23 1.14-32.46 1.97-48.68.88-17.3-4.27-35.42-10.35-52.18-3.5-9.65-7.24-16.25-14.32-24.59-3.83-4.52-7.45-9.13-10.85-13.83"
      style={{
        fill: "none",
        stroke: "#98919c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M362.74 204.4c-2.25-3.99-3.97-8.07-5.17-12.23"
      style={{
        fill: "none",
        stroke: "#695f6f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m253.23 154.4-5.96.61c-.88.09-1.54.85-1.5 1.74.1 2.03.68 3.8 1.73 5.31"
      style={{
        fill: "none",
        stroke: "#68556f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M438.76 129.02c-.2 4.19-.03 8.35.5 12.49.52 4.08 0 9.09 1.75 13.51"
      style={{
        fill: "none",
        stroke: "#7e6b85",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M441.01 155.02c-.23 2.06-.2 4.28.08 6.67.85 7.3 1.07 15.72 2.94 23.8.86 3.71 1.49 7.88 1.89 12.52 1.05 12.11 1.99 24.31 2.82 36.59M454.49 334.15c-2.4 5.31-2.57 9.75-.88 15.71 2.29 8.03 4.78 15.9 6 24.11.97 6.49 1.82 12.99 2.56 19.51.91 8.07.59 16.35 1.22 24.52.15 1.96 1.08 3.77 1.52 5.79"
      style={{
        fill: "none",
        stroke: "#68556f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M472 527.36c-.36 2.78-.32 5.77.11 8.98.36 2.68-.4 3.05-2.27 1.1a15.803 15.803 0 0 0-3.8-2.92c-.33-.18-.57-.45-.71-.81-.99-2.6-2.51-4.84-4.56-6.73-.22-.21-.35-.46-.39-.76-.31-2.68-1.31-5.04-3-7.09-4.79-5.82-10.86-11.08-15.12-16.5-11.91-15.14-23.44-33.51-28.18-52.43"
      style={{
        fill: "none",
        stroke: "#7e6b85",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M414.08 450.2c-5.49-23.09-7.89-45.36-10.5-67.77-.88-7.59-1.38-14.23-1.49-19.93-.65-32.26 4.38-64.62-.31-96.7"
      style={{
        fill: "none",
        stroke: "#68556f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M401.78 265.8c-.92-8.57-4.36-15.19-6.53-23.24-4.16-15.5-14.73-40.05-30.27-46.93"
      style={{
        fill: "none",
        stroke: "#7e6b85",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m364.98 195.63-5.06-4.43M253.07 146.14l-5.96 5.39c-.27.24-.58.32-.93.23-.68-.17-1.3-.06-1.87.31-.89.59-2.08-.03-2.1-1.1-.01-.97-.31-1.81-.88-2.52"
      style={{
        fill: "none",
        stroke: "#68556f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M279.08 95.44c.88-.61 1.05-1.62.5-3.03-.13-.32-.36-.5-.7-.54-.76-.09-1.55.26-2.37 1.04"
      style={{
        fill: "none",
        stroke: "#cfc3d2",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M251.1 88.96c1.23-9.4 2.28-16.74 7.56-24.21"
      style={{
        fill: "none",
        stroke: "#68556f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M263.22 59.62c4.29-.77 7.04-3.33 8.25-7.7"
      style={{
        fill: "none",
        stroke: "#cfc3d2",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m279.24 261.21-6.77-.08"
      style={{
        fill: "none",
        stroke: "#514554",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m259.03 257.65-1.55.28"
      style={{
        fill: "none",
        stroke: "#98919c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M257.48 257.93c-1.86-.83-3.7-.92-5.53-.27"
      style={{
        fill: "none",
        stroke: "#695f6f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m251.95 257.66-9.88-1.57"
      style={{
        fill: "none",
        stroke: "#98919c",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M362.74 204.4c-2.8-2.19-5.87-3.4-9.22-3.65a.54.54 0 0 1-.49-.65l.93-4.37c.07-.34.24-.61.51-.82.71-.56 1.14-1.21 1.29-1.95"
      style={{
        fill: "none",
        stroke: "#d0cdd2",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M461.57 569.4c2.16 3.31 5.15 5.14 8.98 5.49.31.03.6.13.85.32 1.07.78 2.17 1.5 3.32 2.17 2.77 1.61 4.59 3.28 7.08 5.01.22.15.36.39.39.66.18 1.55 1.03 2.55 2.56 3.01.29.09.52.27.68.52.29.46.74.84 1.34 1.13 4.81 2.34 8.21 6.01 6.38 11.77"
      style={{
        fill: "none",
        stroke: "#695f6f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M493.15 599.48c-.07.05-.22.04-.44-.02M243.06 356.78l.33-7.69"
      style={{
        fill: "none",
        stroke: "#a091a5",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M235.35 270.67c.63 1.31.48 2.73-.46 4.26"
      style={{
        fill: "none",
        stroke: "#7e7485",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M306.63 25.16c-.2-.59-.83-.92-1.42-.73l-12.6 4.07c-.59.19-.92.83-.73 1.42l.04.11c.2.59.83.92 1.42.73l12.6-4.07c.59-.19.92-.83.73-1.42l-.04-.11M413.03 42.46s-.38-.02-.82 0c-.35 0-.5.15-.46.43.02.16.11.33.28.5 1.7 1.8 3.36 3.67 4.98 5.61.2.24.58.05.5-.25-.69-2.68-2.18-4.77-4.48-6.28"
      style={{
        fill: "none",
        stroke: "#3b2e43",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M275.94 105.44c5.54-6.05-.55-11.7-7.26-9.27-.36.13-.4.33-.11.58 2.68 2.31 4.67 5.13 5.98 8.44.33.82.79.9 1.39.25M246.18 106.48c.32.17.71-.06.71-.42l.06-4.76a.797.797 0 0 0-.9-.81l-2.89.34c-.72.08-1.15.84-.86 1.51.82 1.83 2.11 3.21 3.88 4.14M249.54 101.82l-.48 5.84c-.04.52.34.97.85 1.01l.44.03c6.3.52 11.55-.76 11.72-2.85v-.1c.18-2.1-4.78-4.22-11.09-4.74l-.44-.04a.93.93 0 0 0-1 .85"
      style={{
        fill: "none",
        stroke: "#8d8690",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M264.87 150.54c-5.73 2.57-10.3 8.76-14.72 12.1-.55.41-1.3 1.34-2.25 2.79"
      style={{
        fill: "none",
        stroke: "#5d5462",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M247.9 165.43c-3.42 3.08-8.42 6.75-10.08 11.11a76.69 76.69 0 0 0-2.73 8.76"
      style={{
        fill: "none",
        stroke: "#3b2e43",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M235.09 185.3c-4.52 8.18-10.27 18.68-17.73 25.14-6.76 5.86-12.36 14.98-17.92 21.76-1.37 1.67-1.51 1.57-.42-.29l4.31-7.38"
      style={{
        fill: "none",
        stroke: "#8d8690",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m203.33 224.53 5.12-9.48c.57-1.06.42-1.18-.47-.35-1.56 1.45-2.93 1.15-4.43 2.37a62.997 62.997 0 0 0-12.19 13.33c-1.34 1.97-1.68 4.67-3.79 6.76-1.13 1.12-1.07 2.54-2.53 3.8-.94.83-1.76 1.82-2.45 2.98-.15.26-.23.54-.23.85v6.14c0 .27.16.5.4.6 2.02.83 3.75.47 5.2-1.08.13-.14.33-.22.53-.2 1.34.11 2.54-.21 3.61-.98.29-.21.62-.37.97-.48l3.48-1.04"
      style={{
        fill: "none",
        stroke: "#5d5462",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M196.55 247.75c25.13-2.7 52.97-2.86 77.14 4.11 3.33.96 13.49 2.99 15.94.27a1027.39 1027.39 0 0 1 44.96-46.71c.07-.06 0-.17-.09-.14a77.754 77.754 0 0 1-21.23 5.05c-1.29.12-1.29.07-.02-.16 10.74-1.92 20.3-6.35 28.67-13.29.09-.07.11-.2.05-.29a.23.23 0 0 0-.28-.1c-6.71 2.66-13.61 4.37-20.69 5.12-.28.03-.52-.02-.71-.14-.22-.15-.2-.23.06-.24 12.66-.92 22.26-6.67 31.34-15.38 2.13-2.05 3.76-2.83 1.84-5.6-4.31-6.21-7.68-9.4-12.48-14.07-.48-.47-.39-.63.26-.49 4.8 1.04 12.27 10.91 14.48 14.42.16.26.33.27.52.02 2.71-3.66-1.08-8.13-4.16-10.13-17.05-11.1-27.45-17.96-39.61-28.94a.763.763 0 0 0-.84-.12c-4.02 1.97-8.29 2.87-11.91 5.27-3.8 2.53-11.87 9.13-16.6 7.61-1.85-.59-2.92-1.87-3.23-3.83-.7-4.5 3.65-7.21 5.85-10.73.35-.55.24-.67-.33-.35l-20.61 11.63"
      style={{
        fill: "none",
        stroke: "#8d8690",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M196.55 247.75c-2.57-.53-5.27-.54-8.08 0-1.19.22-2.3-.7-2.29-1.91.02-3.46 3.46-6.31 4.95-8.85 2.77-4.7 6.19-9.09 10.26-13.17.38-.38.97-.45 1.42-.15.25.17.43.46.52.87"
      style={{
        fill: "none",
        stroke: "#d0cdd2",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M235.09 185.3c4.31-6.89 6.44-12.04 13.26-18.8"
      style={{
        fill: "none",
        stroke: "#aea7b2",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M248.35 166.5c5.36-6.25 13.88-6.01 16.52-15.96"
      style={{
        fill: "none",
        stroke: "#d0cdd2",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m248.35 166.5-.45-1.07"
      style={{
        fill: "none",
        stroke: "#7e7485",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M232.96 168.4c1.29-.89 2.07-2.17 2.34-3.86.17-1.06-.99-1.82-1.89-1.24-2.21 1.43-2.56 3.5-1.07 6.21.12.22.43.24.57.03.13-.19.12-.37-.02-.54-.2-.23-.18-.43.07-.6"
      style={{
        fill: "none",
        stroke: "#3b2e43",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M334.82 209.38a645.313 645.313 0 0 1-24.5 24.58c-6.32 6.01-12.09 12.84-18.28 19.19-.27.27-.21.43.18.46 4.39.39 13.36.12 16.09-4.05 9.84-15.01 20.65-29.3 32.42-42.86 1.95-2.25 3.88-4.24 5.77-5.99.22-.21.19-.26-.09-.16-5.45 1.93-7.82 4.83-11.59 8.83"
      style={{
        fill: "none",
        stroke: "#8d8690",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M393.93 128.27c3.36 1.68 6.93 1.24 10.71-1.32.18-.13.12-.41-.1-.44l-.6-.09"
      style={{
        fill: "none",
        stroke: "#cfc3d2",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M403.94 126.42c10.8-2.76 19.43-13.96 6.78-22.15-11.84-7.66-22.08-7.42-35.42-9.16-7.49-.98-13.87 2.37-19.87 6.86-9.65 7.23-4.62 17.42 4.81 20.82 11.07 4 22.3 5.83 33.69 5.48"
      style={{
        fill: "none",
        stroke: "#5d4a63",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m403.94 126.42-10.01 1.85M397.18 112.31c-3.27-4.34-25.8-4.39-30.82-3.99-1.08.09-1.53 1.43-.72 2.16 8.02 7.16 21.74 5.88 31.35 2.46.35-.13.41-.34.19-.63"
      style={{
        fill: "none",
        stroke: "#8d8690",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M422.68 495.82c.38.43.58.93.6 1.48.01.31.1.62.26.89 4.25 6.93 6.5 14.05 12.73 20.79.22.24.44.79.65 1.65.07.31.26.5.56.59.88.25 1.42.85 1.61 1.78.06.31.21.56.46.76l4.7 3.71c.27.21.47.47.61.78.25.55.65.95 1.21 1.18.52.22.6.12.23-.31-.69-.81-1.06-1.74-1.1-2.78-.01-.33-.13-.62-.35-.87-2.15-2.45-3.74-5.2-4.78-8.25-2.96-8.69-11.18-13.42-14.8-21.4-2.14-4.71-3.8-10.22-6.43-14.61-1.1-1.83-2.08-3.32-2.94-4.45-1.53-2.03-1.92-1.83-1.17.6 2.02 6.53 3.37 13.21 7.95 18.46"
      style={{
        fill: "none",
        stroke: "#47394f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M293.28 326.28c-4.31-.3-7.58-2.27-9.83-5.91-.17-.28-.6-.15-.59.18.19 5.39.17 10.79-.04 16.21-.08 2.07.66 3.66 2.21 4.76 11.52 8.21 24.33 12.19 38.42 11.95 16.8-.29 22.35-9.11 32.91-19.71 4.37-4.37 7.02-7.3 7.95-8.77 5.69-8.98 4.66-16.65 1.43-26.44-2.55-7.75-2.1-22.17-12.7-25.03-2.61-.71-4.94-.66-7.25-2.08-1.79-1.1-5.64-4.91-7.39-1.79-.16.28-.14.64.07.9 2.91 3.74 8.1 6.12 9.07 10.94 1.07 5.3 2.26 13.49 0 18.81-6.81 16.11-33.89 32.62-51.57 26.68a.924.924 0 0 1-.64-.84l-.13-3.4c0-.16-.13-.29-.29-.31-.17 0-.31.09-.35.25l-.75 3.2c-.07.29-.25.42-.54.4"
      style={{
        fill: "none",
        stroke: "#8d8690",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m338.22 318.57.74.65c.06.06.16.05.21-.01l.16-.18c5.35-6.09 9.48-11.2 9.24-11.41l-.08-.07c-.24-.22-4.78 4.54-10.12 10.63l-.16.18c-.06.06-.05.16.01.21M361.04 324.12l.82.19c.09.02.19-.04.21-.14l2.53-11.04c.68-2.99 1-5.47.7-5.53l-.09-.03c-.3-.06-1.1 2.3-1.78 5.29l-2.53 11.05c-.02.09.04.19.14.21M354.21 314.49c-2.9 4.33-6.47 8.36-11.06 10.96-15.58 8.82-34.59 15.11-51.9 9.43-.24-.08-.42.24-.22.4 9.38 7.67 19.44 9.61 31.13 7.59 5.45-.94 11.52-2.14 16.6-4.33 7.37-3.19 13.49-16.68 15.69-23.94.02-.06-.01-.13-.07-.16s-.13-.01-.17.05"
      style={{
        fill: "none",
        stroke: "#8d8690",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M229.92 359.28c-1.34 3.99-2.31 7.81-2.9 11.47-4.3 26.54-9.42 51.9-9.74 80.07-.09 7.96-.55 15.78-.72 23.68-.19 8.73 1.37 17.86 2.07 26.88.16 2.04 1.19 4.1 1.22 6.37"
      style={{
        fill: "none",
        stroke: "#5d4a63",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M219.85 507.75c-.31 6.91 3.5 13.8 6.62 20.77 1.17 2.59 2.52 4.75 4.06 6.48"
      style={{
        fill: "none",
        stroke: "#3b2e43",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m230.53 535 3.17 5.57c.17.3.26.28.28-.07.33-6.46.1-12.85-.67-19.16-1.74-14.19-.81-29.27-.79-43.56"
      style={{
        fill: "none",
        stroke: "#5d4a63",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m232.52 477.78.68-6.06c.01-.15-.05-.22-.2-.22h-.29a.447.447 0 0 0-.46.39c-.37 2.49-1.72 4.16-4.05 5"
      style={{
        fill: "none",
        stroke: "#3b2e43",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M228.2 476.89c-.39-5.85-.21-11.63.52-17.32 1.96-15.34 1.16-31.69 1.39-47.19.27-17.82 4.91-34.19 2.49-52.26"
      style={{
        fill: "none",
        stroke: "#5d4a63",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M232.6 360.12c.24-2.07-.05-4.2-.88-6.39a.44.44 0 0 0-.79-.07c-1.31 2.17-1.64 4.05-1.01 5.62"
      style={{
        fill: "none",
        stroke: "#26182d",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m232.6 360.12-1.31 17.79c-.03.28-.16.34-.39.19-.11-.07-.16-.19-.17-.35-.21-6.01-.48-12.16-.81-18.47"
      style={{
        fill: "none",
        stroke: "#68556f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m228.2 476.89-.38 2.56c-.05.37.39.59.65.33l3.36-3.32c.25-.25.45-.22.58.11.13.32.17.72.11 1.21M230.53 535c-4.2-8.95-8.3-17.58-10.68-27.25"
      style={{
        fill: "none",
        stroke: "#7e6b85",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="m244.07 381.21-.9-.07a.142.142 0 0 0-.16.14l-.18 2.21c-.84 10.46-1.27 18.97-.95 18.99h.04c.32.03 1.26-8.43 2.11-18.9l.17-2.21a.146.146 0 0 0-.13-.16"
      style={{
        fill: "none",
        stroke: "#5d5462",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M284.43 627.92c-.99 2.89 3.26 4.23 4.53 6.55.39.71 1.13 1.16 1.95 1.17l12.96.15a.8.8 0 0 0 .71-1.19l-.99-1.75c-.18-.32-.45-.53-.8-.64-3.39-1.02-5.57-3.36-8.7-4.23a58.68 58.68 0 0 0-7.27-1.52c-1.04-.15-2.05.46-2.39 1.46"
      style={{
        fill: "none",
        stroke: "#47394f",
        strokeWidth: ".3px",
      }}
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M271.47 51.92c-1.21 4.37-3.96 6.93-8.25 7.7 2.39-3.06 5.14-5.63 8.25-7.7ZM279.08 95.44l-2.57-2.53c.82-.78 1.61-1.13 2.37-1.04.34.04.57.22.7.54.55 1.41.38 2.42-.5 3.03ZM275.94 105.44c-.6.65-1.06.57-1.39-.25-1.31-3.31-3.3-6.13-5.98-8.44-.29-.25-.25-.45.11-.58 6.71-2.43 12.8 3.22 7.26 9.27ZM246.18 106.48c-1.77-.93-3.06-2.31-3.88-4.14-.29-.67.14-1.43.86-1.51l2.89-.34c.49-.06.91.32.9.81l-.06 4.76c0 .36-.39.59-.71.42ZM249.54 101.82a.93.93 0 0 1 1-.85l.44.04c6.31.52 11.27 2.64 11.1 4.74v.1c-.18 2.09-5.43 3.37-11.73 2.85l-.44-.03a.933.933 0 0 1-.85-1.01l.48-5.84ZM366.36 108.32c5.02-.4 27.55-.35 30.82 3.99.22.29.16.5-.19.63-9.61 3.42-23.33 4.7-31.35-2.46-.81-.73-.36-2.07.72-2.16ZM403.94 126.42l.6.09c.22.03.28.31.1.44-3.78 2.56-7.35 3-10.71 1.32l10.01-1.85ZM196.55 247.75c-2.57-.53-5.27-.54-8.08 0-1.19.22-2.3-.7-2.29-1.91.02-3.46 3.46-6.31 4.95-8.85 2.77-4.7 6.19-9.09 10.26-13.17.38-.38.97-.45 1.42-.15.25.17.43.46.52.87l-4.31 7.38c-1.09 1.86-.95 1.96.42.29 5.56-6.78 11.16-15.9 17.92-21.76 7.46-6.46 13.21-16.96 17.73-25.14 4.31-6.89 6.44-12.04 13.26-18.8 5.36-6.25 13.88-6.01 16.52-15.96l20.61-11.63c.57-.32.68-.2.33.35-2.2 3.52-6.55 6.23-5.85 10.73.31 1.96 1.38 3.24 3.23 3.83 4.73 1.52 12.8-5.08 16.6-7.61 3.62-2.4 7.89-3.3 11.91-5.27.28-.13.61-.09.84.12 12.16 10.98 22.56 17.84 39.61 28.94 3.08 2 6.87 6.47 4.16 10.13-.19.25-.36.24-.52-.02-2.21-3.51-9.68-13.38-14.48-14.42-.65-.14-.74.02-.26.49 4.8 4.67 8.17 7.86 12.48 14.07 1.92 2.77.29 3.55-1.84 5.6-9.08 8.71-18.68 14.46-31.34 15.38-.26.01-.28.09-.06.24.19.12.43.17.71.14 7.08-.75 13.98-2.46 20.69-5.12.1-.04.22 0 .28.1.06.09.04.22-.05.29-8.37 6.94-17.93 11.37-28.67 13.29-1.27.23-1.27.28.02.16 7.33-.69 14.4-2.37 21.23-5.05.09-.03.16.08.09.14a1027.39 1027.39 0 0 0-44.96 46.71c-2.45 2.72-12.61.69-15.94-.27-24.17-6.97-52.01-6.81-77.14-4.11ZM355.76 192.96c-.15.74-.58 1.39-1.29 1.95-.27.21-.44.48-.51.82l-.93 4.37c-.07.32.16.62.49.65 3.35.25 6.42 1.46 9.22 3.65 3.4 4.7 7.02 9.31 10.85 13.83 7.08 8.34 10.82 14.94 14.32 24.59 6.08 16.76 11.23 34.88 10.35 52.18-.83 16.22-1.48 32.45-1.97 48.68-.5 16.9-.26 29.92.72 39.07 3.36 31.46 6.66 62.5 14.48 93.25.63 2.48 2.1 6.34 4.41 11.57 3.85 8.72 10.3 21.08 17.33 30.13 2.71 3.49 5.08 7.09 8.31 10.18 4.59 4.39 8.95 8.97 13.08 13.74l4.37 5.32.77 5.33.3 6.95-.03 9.71c0 .1.03.21.08.29l2.86 4.59c.15.25.37.41.65.48 3.33.86 6.22 2.39 8.68 4.59 4.96 4.44 10.08 7.83 15.61 11.48 3.65 2.42 5.38 4.8 4.8 9.1-3.32 6.62-9.99 4.65-16.08 4.98-2.06.11-4.16-.64-6.42-.82-6.03.17-12.16 1.07-18.37 2.7-4.28 1.12-7.58 3.81-11.09 6.4-12.4 9.17-25.29 7.72-40.25 8.58a5.94 5.94 0 0 0-3.05.43c-2.63.38-5.23.23-7.82-.45-5.42-1.42-10.95-1.19-16.49-1.59-1.79-.13-3.59-1.36-5.4-1.44-6.89-.31-13.78-.77-20.65-.75-16.12.06-32.61-.83-48.66.45-10 .8-16.94.25-24.81-5.96-8.85-6.44-17.6-15.07-21.07-25.51-2.19-6.6-3.83-13.33-4.9-20.2-.51-3.28-1.89-6.52-2.46-9.95-1.05-6.33-2-10.77-.14-16.24 1.02-3.02.4-5.49.4-8.48.36-10.72-1.37-21.52-1.46-31.45-.34-35.8-.4-63.67-.19-83.6.13-11.92 4.22-22.4 1.16-33.55-1.46-5.28-1.65-10.68-2.46-15.94.66-2.13.87-4.07.63-5.82 1.3-7.38.59-12.89 1.31-19.47.27-2.43 1.06-5.72 2.38-9.89 3.22-10.21 4.58-21.22 7.56-30.74 1.44-4.58 2.98-9.15 4.62-13.72 3.85-4.96 8.72-7.44 12.17-13.35l7.98-1.16c.75.7 1.46.89 2.13.58.48-.22.57-.59.27-1.12 8.38-2.03 16.67-4.21 24.87-6.52 6.24-1.76 6.14-5.84 10.55-9.4 9.97-8.05 15.52-16.14 20.05-27.84 1.83-4.71 4.14-9.17 6.95-13.37 4.55-6.79 6.62-11.24 7.95-18.52.28-1.52 1.56-2.78 3.84-3.77Zm-62.48 133.32c-4.31-.3-7.58-2.27-9.83-5.91-.17-.28-.6-.15-.59.18.19 5.39.17 10.79-.04 16.21-.08 2.07.66 3.66 2.21 4.76 11.52 8.21 24.33 12.19 38.42 11.95 16.8-.29 22.35-9.11 32.91-19.71 4.37-4.37 7.02-7.3 7.95-8.77 5.69-8.98 4.66-16.65 1.43-26.44-2.55-7.75-2.1-22.17-12.7-25.03-2.61-.71-4.94-.66-7.25-2.08-1.79-1.1-5.64-4.91-7.39-1.79-.16.28-.14.64.07.9 2.91 3.74 8.1 6.12 9.07 10.94 1.07 5.3 2.26 13.49 0 18.81-6.81 16.11-33.89 32.62-51.57 26.68a.924.924 0 0 1-.64-.84l-.13-3.4c0-.16-.13-.29-.29-.31-.17 0-.31.09-.35.25l-.75 3.2c-.07.29-.25.42-.54.4Z"
      style={{
        fill: "#fff",
      }}
    />
    <path
      d="M334.82 209.38c3.77-4 6.14-6.9 11.59-8.83.28-.1.31-.05.09.16a75.888 75.888 0 0 0-5.77 5.99 399.244 399.244 0 0 0-32.42 42.86c-2.73 4.17-11.7 4.44-16.09 4.05-.39-.03-.45-.19-.18-.46 6.19-6.35 11.96-13.18 18.28-19.19 8.39-7.97 16.55-16.17 24.5-24.58ZM242.07 256.09l9.88 1.57 5.53.27 1.55-.28 13.78 2.85c-.21.2-.32.41-.34.63-.58-.25-1.07-.23-1.48.06l-6.46.61c-4.25-.98-8.89-.79-12.67-1.29a94.56 94.56 0 0 0-10.49-.79c-2.22-.04-4.93.96-7.42.64-9.31-1.19-18.83-1.13-28.25-1.87l-3.77-.48c-.67-.09-.73-1.03-.08-1.2.71-.18 1.51-.58 2.25-.61 12.59-.41 25.25-.45 37.97-.11ZM338.22 318.57a.145.145 0 0 1-.01-.21l.16-.18c5.34-6.09 9.88-10.85 10.12-10.63l.08.07c.24.21-3.89 5.32-9.24 11.41l-.16.18c-.05.06-.15.07-.21.01l-.74-.65ZM361.04 324.12a.18.18 0 0 1-.14-.21l2.53-11.05c.68-2.99 1.48-5.35 1.78-5.29l.09.03c.3.06-.02 2.54-.7 5.53l-2.53 11.04a.18.18 0 0 1-.21.14l-.82-.19ZM343.15 325.45c4.59-2.6 8.16-6.63 11.06-10.96.04-.06.11-.08.17-.05s.09.1.07.16c-2.2 7.26-8.32 20.75-15.69 23.94-5.08 2.19-11.15 3.39-16.6 4.33-11.69 2.02-21.75.08-31.13-7.59-.2-.16-.02-.48.22-.4 17.31 5.68 36.32-.61 51.9-9.43ZM315.95 638.71c7.99 1.36 15.86 1.52 23.59.49.13-.02.26.01.37.08.42.27.44.58.05.91-1.09.6-2.21.9-3.22 1.52-7.53 4.62-15.51 9.06-22.21 14.33-6.84 5.39-14.8 11.4-20.37 18.1-1.84 1.26-4.94.53-7.2.94-6.09 1.09-13.01 1.45-18.22 2.57-3.39.73-6.78 1.68-10.18 2.84-.75.25-1.41-.56-1-1.24 1.25-2.03 1.97-4.31 2.16-6.83a29.85 29.85 0 0 0 1.77-9.55l.06-1.39c.19-.49.61-.89 1.26-1.22.39-.2.39-.4 0-.61-.35-.18-.78-.22-1.27-.13-.11-.63-.31-1.03-.6-1.21-7.58-4.61-16.09-6.86-25.54-6.74 3-1.41 5.94-2.46 8.81-3.13 10.74-2.49 21.04-6.21 31.83-8.73 3.06 1.96 5.79 3.85 9.61 4.08 8.27.51 14.37.49 18.31-.08 2.97-.43 6.97-2.09 11.99-5ZM429.84 642.1c2.56 9.9 6.24 22.16 2.27 32.14-.52 1.31-1.49 1.96-2.91 1.93-2.24-.04-4.96.5-8.17 1.62-6.5 3.08-12.93 6.9-19.3 11.45-.33.23-.69.33-1.09.3l-3.21-.25c-.4-.03-.74-.3-.86-.68l-2.23-7.23c-.56-5.14-.32-9.79-1.88-15.11-1.05-3.56-7.28-1.91-9.38-.84-7.38 3.11-10.58 7.02-15.28 12.03-.49.52-1.34-.03-1.06-.69 1.26-3.01 2.99-5.73 5.18-8.16.23-.26.36-.56.39-.91.21-2.78 1.41-4.95 3.61-6.52.33-.24.44-.56.33-.96-.18-.63.05-1.07.7-1.32.28-.11.48-.3.59-.57.76-1.87 1.65-3.22 2.27-5.28.91-3.07 2.75-5.46 5.52-7.16.29-.18.61-.26.95-.23 5.63.44 11.13-.1 16.49-1.63 3.81-1.09 6.54-1.17 10.22-.96.35.03.6.17.73.44.13.28.35.46.65.55 5.09 1.44 10.24.79 15.47-1.96Z"
      style={{
        fill: "#fff",
      }}
    />
    <path
      d="M337.5 17.36c7.82.55 15.65.9 23.49 1.06 15.33.31 32.5 6.39 46.46 12.51 13.34 5.84 24.43 26.04 28.52 39.34 2.3 7.45 5.11 15.31 6.76 22.39 2.61 11.17 4.33 22.53 5.15 34.06-.87 6.43-.67 12.54.62 18.32 1.83 14.33 5.68 28.05 7.41 42.39 1.36 11.25 2.83 22.03 2.86 33.48.05 16.11.09 32.23.11 48.34.02 12.41 1.83 24.93 3.84 37.16.55 3.36.96 6.72 1.23 10.09-.89 11.17-.44 23.4 1.36 36.69.61 4.45 1.17 7.5 1.7 9.13 1.12 12.88 1.62 25.85 1.51 38.9-.03 3.63 1.49 7.27 1.32 10.77-.21 4.27-.13 7.9.22 10.89 2 17.21 3.15 34.64 4.61 51.91.08.99.74 7.62 1.97 19.89 2.01 20 2.31 40.04.89 60.13-.03.34-.19.59-.49.74-2.69 1.37-7.9-1.53-10.4-2.1-1.47-.33-2.12.25-1.95 1.75l1.07 9.47c.03.29.15.55.34.76 1.98 2.16 4.5 4.14 7.56 5.93 8.25 4.83 16.4 9.84 24.45 15.02 3.73 2.4 5.3 5.85 4.72 10.35-1.19 9.1-3.49 12.69-12.2 15.8-10.5 3.74-24.39-5.42-30.34 9.25-1.83 4.5-11.14 10.08-15.23 12.8-2.29 1.51-4.33 3.95-6.14 7.32-.15.27-.21.57-.2.88.19 4.55.52 9.09.99 13.62.36 3.37-.27 6.14-.89 9.35-1.67 2.47-2.63 5.1-2.9 7.87-.45 4.7-2.31 8.63-3.81 12.97-.11.33-.31.6-.59.8-1.87 1.32-3.92 2.03-6.17 2.14-4.16.21-6.59 1.69-10.04 3.77-1.41.85-3.15.93-4.5 2.02-2.94 2.37-6.09 5.52-9.68 6.77-1.49.51-3.01.97-4.57 1.37-.3.08-.62.04-.9-.1-1.29-.65-2.89-.98-4.8-.99-1.88-6.32-3.19-13.37-3.94-21.16a1.66 1.66 0 0 0-2.19-1.4c-8.61 2.99-16.66 11.16-24.04 16.9-.81.63-1.57.58-2.3-.13-2.46-2.38-.03-9.73.47-12.83 2.21-13.7 8.88-23.73 16.27-35.28.82-1.29 1.17-2.96 1.99-4.26 1.14-1.18 1.63-2.92 1.48-5.21a.913.913 0 0 0-.47-.75l-3.02-1.73a.846.846 0 0 1 .16-1.54l9.67-3.16c.23-.07.48.02.62.22l2.69 4.05c.23.36.18.66-.17.9l-1.39.97c-.35.33-.66.74-.95 1.21-5.66 9.49-12.27 17.44-16.48 27.85-.13.31-.18.64-.17.97.03 1.07-.38 2.16-1.25 3.27-2.06 2.62-3.09 5.88-3.1 9.78 0 .34.12.39.36.15 5.71-5.65 11.02-11.36 17.98-15.76 2.1-1.07 8.33-2.72 9.38.84 1.56 5.32 1.32 9.97 1.88 15.11-.29 3.76.17 11.41 5.54 8.93.29-.13.6-.19.91-.18 4.07.19 8.52-3.92 11.39-6.87.23-.24.52-.41.83-.5 2.3-.67 4.07-2.03 6.34-2.71 1.5-.45 2.06-1.2 1.68-2.26 3.21-1.12 5.93-1.66 8.17-1.62 1.42.03 2.39-.62 2.91-1.93 3.97-9.98.29-22.24-2.27-32.14.13-.33.08-1.1-.17-2.3a.756.756 0 0 0-.96-.58l-9.27 2.8c-.43-.32-.7-.61-.81-.86-.1-.24-.28-.34-.53-.31-.8.11-1.24-.26-1.32-1.12-.25-2.69 1.33-6.14 1.45-8.68.11-2.48-.25-4.9-1.08-7.27-.1-.28-.49-.28-.58 0l-.11.35c-.08.23-.22.28-.42.16l-.34-.2c-.24-.15-.22-.25.05-.3.45-.09.79-.29 1.01-.6 2.6-.22 5.17-.93 7.72-2.13 3.13-1.13 6.35-1.35 9.67-.66.35.07.65.28.85.57 2.49 3.81 2.72 9.97 3.19 14.56.09.87 1.11 1.28 1.78.73l5.95-4.87c.89-.73 2.11-1.84 3.53-3.22 5.51-5.36 5.91-6.45 6.33-14.44.17-3.22 1.56-5.27 4.17-6.16 1.17-.4 3.38-.51 6.61-.32 8.88.5 17.73 1.79 26.81.11 3.54-.65 4.96-3.27 4.11-6.6-.08-.3 0-.62.24-.84.7-.66.83-1.38.39-2.15-.16-.29-.23-.61-.22-.94.1-2.81-.65-5.34-2.24-7.59-1.15-1.63-2.83-1.92-4.49-3.02-.27-.18-.46-.43-.56-.74-.66-2.03-1.83-1.97-3.29-2.82a335.88 335.88 0 0 0-6.9-3.87c-.27-.14-.45-.36-.55-.65-.19-.55-.66-.92-1.39-1.11-3.15-.81-6.03-2.53-8.64-5.15a1.05 1.05 0 0 0-.84-.32c-2.47.13-4.95-.59-7.42-2.16l-1.51-10.18-.3-6.95c.45-.29.61-.79.49-1.5-.28-1.59.22-2.97 1.98-3.2 1.21-.16 2.46.76 3.42 1.46l8.18 3.9c.41.19.62.06.64-.39.09-1.89.05-4.42-.13-7.61-.37-6.73-1.15-12.58-2.34-17.57-.29-5.35-1.8-10.93-1.89-15.85-.1-5-.02-10 .25-15.01.11-2.09-.85-5.2-.88-7.69-.27-22.48-1.04-43.28-4.57-65.02.13-5.9-.35-11.7-.35-17.56 0-2.67-.83-5.8-.93-7.83-.49-9.77.63-19.49-.08-29.16-.25-3.5-.44-7.01-.55-10.52a.756.756 0 0 0-.75-.72h-3.78c-.63 0-1.17-.44-1.3-1.06-1.55-7.49-2.45-15.09-2.68-22.79 1.67-2.18 2.01-4.34 1.04-6.48a.746.746 0 0 0-.79-.43c-.89.14-1.61-.13-2.18-.8-.24-.29-.36-.61-.36-.98-.05-13.13-.12-26.25-.21-39.37v-.01a1.73 1.73 0 0 0-.27-.08.34.34 0 0 1-.27-.33c-.11-10.19-.78-20.7-.2-30.91.02-.35-.2-.74-.65-1.15a1.25 1.25 0 0 1-.41-.84l-1.44-18.17c.43-3.42.52-6.79.26-10.11-.26-3.36 2.58-8.22 2.54-12.61-.08-7.59-1.45-15.71-1.72-22.53-.17-4.37-.38-8.69-.61-12.94a3.102 3.102 0 0 0-2.92-2.93c-.45-.03-.85-.63-1.19-1.81-1.56-5.37-2.85-11-3.86-16.89.12-8.67-.71-17.25-2.48-25.76-1.74-20.23-5.69-39.94-11.84-59.15-3.89-12.14-10.87-20.47-19.65-28.15-9.03-7.89-21.05-11.74-32.48-14.59-.33-.08-.6 0-.83.25-2.51 2.78-5.09 3.71-9.04 3.09-16.92-2.66-33.92-2.65-50.98-2.82-.33-.01-.63.07-.9.23-4.47 2.55-10.09 5.41-16.84 8.57-8.75 4.09-17 9.25-24.73 15.47-3.11 2.07-5.86 4.64-8.25 7.7l-4.56 5.13c-5.03 4.16-8.05 11.04-10.86 16.79-1.12 2.29-1.91 4.77-2.38 7.42-.08.43.1.62.53.57l5.15-.57c.69.37 1.58.47 2.65.29 8.17-1.37 15.75-.15 22.76 3.66l1.46 1.26 1.11 1.26c4.99 4 2.11 11.37-3.12 13.74-.29.13-.54.35-.7.62-.99 1.68-1.44 3.93-2.33 5.32-4.89 7.59-14.18 9.34-23.07 11.22-.36.07-.67-.02-.92-.28l-.42-.42a.854.854 0 0 0-.79-.23c-1.8.39-3.48.2-5.03-.56a.68.68 0 0 0-.98.6l-.39 23c-1.18 3.76.92 5.06 2 7.81.87 2.22 1.44 4.89 1.71 8.01.03.33.39.53.69.38 1.38-.69 1.97-1.56 1.77-2.59 2.55-2.31 4.46-4.87 5.73-7.66-1.03-.15-1.83-.42-2.39-.81-.3-.21-.43-.49-.38-.86.27-2.12 1.14-4.32 2.61-6.59 8.01-6.37 16.45-12.25 25.32-17.65 5.91-3.6 16.29-2.62 23.05-2.62 12.69 0 14.33 7.57 23.11 13.5 7.9 5.33 15.48 11.44 23.25 16.41 11.54 7.36 25.2 14.02 17.71 29.97-1.01 2.14-2.87 3.96-5.59 5.45l-2.35.97c-.94.05-1.54.31-1.81.79-2.28.99-3.56 2.25-3.84 3.77-1.33 7.28-3.4 11.73-7.95 18.52-2.81 4.2-5.12 8.66-6.95 13.37-4.53 11.7-10.08 19.79-20.05 27.84-4.41 3.56-4.31 7.64-10.55 9.4-8.2 2.31-16.49 4.49-24.87 6.52-.73-.66-1.53-.48-2.4.54l-7.98 1.16a4.8 4.8 0 0 1-.12-2.2c.07-.42-.43-.68-.74-.39-2.86 2.7-6.12 3.66-9.77 2.89-4.36-.92-8.37-.74-12.69-1.92 2.95-1.16 4.92-1.74 5.9-1.74 6.79 0 13.24.19 10.78-8.92l6.46-.61c-.53.13-.62.63-.27 1.48.12.29.04.62-.21.81-1.51 1.18-5.31 2.59-2.51 5.17.25.23.54.34.88.35 4.6.04 10.21-2.63 14.83-3.74 1.91-.46 3.18-1.33 1.93-3.44-.17-.27-.41-.42-.73-.43l-5.67-.18c-2.19-.77-4.33-1.01-6.43-.71l-13.78-2.85a.806.806 0 0 1-.25-.3.566.566 0 0 0-.45-.32c-2.09-.33-5.77-1.17-11.06-2.54-2.22-.57-3.95-.04-5.2 1.6-12.72-.34-25.38-.3-37.97.11-.74.03-1.54.43-2.25.61-.65.17-.59 1.11.08 1.2l3.77.48c-.4 1.08-.71 1.69-.93 1.83-1.5.94-1.17 3.21.54 3.69 1.12.31 1.44 1.13.97 2.46a90.026 90.026 0 0 0-19.03-1.91v-.49c-.01-.33-.18-.53-.51-.58-1.49-.23-3.02-1.02-4.58-2.39-4.07-3.59-8.04-7.01-7.99-12.66.04-4.41 2.06-6.87 4.15-10.48 4.05-7.03 8.86-13.77 14.43-20.23 3.31-3.84 6.13-8.75 9.85-11.83 1.53-1.27 3.15-2.41 4.86-3.42 6.6-3.92 11.35-10.09 14.98-16.76 3.01-5.51.89-8.61 1.26-13.96.46-6.69 2.8-11.33 7.68-16.78.71-.8 1.56-3.04 1.67-4.13.76-7.82 1.38-15.65 1.85-23.49.15-2.45-.26-4.19-1.26-6.27a.587.587 0 0 0-.54-.36 1.09 1.09 0 0 1-.75-.34c-2-1.99-4.1-3.87-6.31-5.62-4.72-3.74-5.41-10.78-1.04-15.04 4.21-4.09 11.15-7.2 13.03-12.95 1.8-5.49 4.12-10.58 6.96-15.25 4.77-8.75 10.56-16.57 17.39-23.47 5.22-6.13 11.33-10.42 17.57-15.27 2.44-1.91 5.89-3.38 8.43-5.83 1.85-.25 3.64-.75 5.39-1.5 4.77-2.02 9.38-2.89 13.94-5.18 3.81-1.9 11.01-2.21 15.22-1.53 2.63.42 5.29.5 7.96.23.19-.02.38-.08.55-.17.22-.12.4-.26.55-.42.04-.04.09-.07.15-.08l5.37-.95Zm-30.87 7.8c-.2-.59-.83-.92-1.42-.73l-12.6 4.07c-.59.19-.92.83-.73 1.42l.04.11c.2.59.83.92 1.42.73l12.6-4.07c.59-.19.92-.83.73-1.42l-.04-.11Zm106.4 17.3s-.38-.02-.82 0c-.35 0-.5.15-.46.43.02.16.11.33.28.5 1.7 1.8 3.36 3.67 4.98 5.61.2.24.58.05.5-.25-.69-2.68-2.18-4.77-4.48-6.28Zm-137.09 62.98c5.54-6.05-.55-11.7-7.26-9.27-.36.13-.4.33-.11.58 2.68 2.31 4.67 5.13 5.98 8.44.33.82.79.9 1.39.25Zm-29.76 1.04c.32.17.71-.06.71-.42l.06-4.76a.797.797 0 0 0-.9-.81l-2.89.34c-.72.08-1.15.84-.86 1.51.82 1.83 2.11 3.21 3.88 4.14Zm3.36-4.66-.48 5.84c-.04.52.34.97.85 1.01l.44.03c6.3.52 11.55-.76 11.72-2.85v-.1c.18-2.1-4.78-4.22-11.09-4.74l-.44-.04a.93.93 0 0 0-1 .85Zm15.33 48.72c-5.73 2.57-10.3 8.76-14.72 12.1-.55.41-1.3 1.34-2.25 2.79-3.42 3.08-8.42 6.75-10.08 11.11a76.69 76.69 0 0 0-2.73 8.76c-4.52 8.18-10.27 18.68-17.73 25.14-6.76 5.86-12.36 14.98-17.92 21.76-1.37 1.67-1.51 1.57-.42-.29l4.31-7.38 5.12-9.48c.57-1.06.42-1.18-.47-.35-1.56 1.45-2.93 1.15-4.43 2.37a62.997 62.997 0 0 0-12.19 13.33c-1.34 1.97-1.68 4.67-3.79 6.76-1.13 1.12-1.07 2.54-2.53 3.8-.94.83-1.76 1.82-2.45 2.98-.15.26-.23.54-.23.85v6.14c0 .27.16.5.4.6 2.02.83 3.75.47 5.2-1.08.13-.14.33-.22.53-.2 1.34.11 2.54-.21 3.61-.98.29-.21.62-.37.97-.48l3.48-1.04c25.13-2.7 52.97-2.86 77.14 4.11 3.33.96 13.49 2.99 15.94.27a1027.39 1027.39 0 0 1 44.96-46.71c.07-.06 0-.17-.09-.14a77.754 77.754 0 0 1-21.23 5.05c-1.29.12-1.29.07-.02-.16 10.74-1.92 20.3-6.35 28.67-13.29.09-.07.11-.2.05-.29a.23.23 0 0 0-.28-.1c-6.71 2.66-13.61 4.37-20.69 5.12-.28.03-.52-.02-.71-.14-.22-.15-.2-.23.06-.24 12.66-.92 22.26-6.67 31.34-15.38 2.13-2.05 3.76-2.83 1.84-5.6-4.31-6.21-7.68-9.4-12.48-14.07-.48-.47-.39-.63.26-.49 4.8 1.04 12.27 10.91 14.48 14.42.16.26.33.27.52.02 2.71-3.66-1.08-8.13-4.16-10.13-17.05-11.1-27.45-17.96-39.61-28.94a.763.763 0 0 0-.84-.12c-4.02 1.97-8.29 2.87-11.91 5.27-3.8 2.53-11.87 9.13-16.6 7.61-1.85-.59-2.92-1.87-3.23-3.83-.7-4.5 3.65-7.21 5.85-10.73.35-.55.24-.67-.33-.35l-20.61 11.63Zm-31.91 17.86c1.29-.89 2.07-2.17 2.34-3.86.17-1.06-.99-1.82-1.89-1.24-2.21 1.43-2.56 3.5-1.07 6.21.12.22.43.24.57.03.13-.19.12-.37-.02-.54-.2-.23-.18-.43.07-.6Zm101.86 40.98a645.313 645.313 0 0 1-24.5 24.58c-6.32 6.01-12.09 12.84-18.28 19.19-.27.27-.21.43.18.46 4.39.39 13.36.12 16.09-4.05 9.84-15.01 20.65-29.3 32.42-42.86 1.95-2.25 3.88-4.24 5.77-5.99.22-.21.19-.26-.09-.16-5.45 1.93-7.82 4.83-11.59 8.83Z"
      style={{
        fill: "#1a0d20",
      }}
    />
    <path
      d="m293.82 325.88.75-3.2c.04-.16.18-.26.35-.25.16.02.28.15.29.31l.13 3.4c.02.39.27.72.64.84 17.68 5.94 44.76-10.57 51.57-26.68 2.25-5.32 1.06-13.51 0-18.81-.97-4.82-6.16-7.2-9.07-10.94a.803.803 0 0 1-.07-.9c1.75-3.12 5.6.69 7.39 1.79 2.31 1.42 4.64 1.37 7.25 2.08 10.6 2.86 10.15 17.28 12.7 25.03 3.23 9.79 4.26 17.46-1.43 26.44-.93 1.47-3.58 4.4-7.95 8.77-10.56 10.6-16.11 19.42-32.91 19.71-14.09.24-26.9-3.74-38.42-11.95-1.55-1.1-2.29-2.69-2.21-4.76.21-5.42.23-10.82.04-16.21 0-.33.42-.46.59-.18 2.25 3.64 5.52 5.61 9.83 5.91.29.02.47-.11.54-.4Zm44.4-7.31.74.65c.06.06.16.05.21-.01l.16-.18c5.35-6.09 9.48-11.2 9.24-11.41l-.08-.07c-.24-.22-4.78 4.54-10.12 10.63l-.16.18c-.06.06-.05.16.01.21Zm22.82 5.55.82.19c.09.02.19-.04.21-.14l2.53-11.04c.68-2.99 1-5.47.7-5.53l-.09-.03c-.3-.06-1.1 2.3-1.78 5.29l-2.53 11.05c-.02.09.04.19.14.21Zm-6.83-9.63c-2.9 4.33-6.47 8.36-11.06 10.96-15.58 8.82-34.59 15.11-51.9 9.43-.24-.08-.42.24-.22.4 9.38 7.67 19.44 9.61 31.13 7.59 5.45-.94 11.52-2.14 16.6-4.33 7.37-3.19 13.49-16.68 15.69-23.94.02-.06-.01-.13-.07-.16s-.13-.01-.17.05ZM238.44 271.56l1.8.12-.78 4.08c-.05.29 0 .55.17.78l3.44 4.82a545.59 545.59 0 0 0-4.05 29.88c-.32 2.97-1.27 5.91-1.9 8.91-1.37 6.5-.57 14.22-.74 20.92-.07 2.74.39 6.1 1.37 10.07.07.32.05.63-.06.94-.41 1.11-.39 2.18.08 3.21.11.24.29.35.55.32l1.31-.13c.45-.05.81.36.7.8-.34 1.35 0 2.39 1.03 3.11.31.22.48.52.52.9l.62 6.78c.81 5.26 1 10.66 2.46 15.94 3.06 11.15-1.03 21.63-1.16 33.55-.21 19.93-.15 47.8.19 83.6.09 9.93 1.82 20.73 1.46 31.45-1.74.46-2.4-.37-1.99-2.49.57-2.93-.42-6.57-.74-9.56-.03-.25-.16-.33-.39-.24-.09.03-.18.1-.25.19-.34.44.15 6.63-.89 8.83-1.62 3.41.46 12.78 1.35 16.81 1 4.49.96 9.1 2.14 13.47.57 2.09 1.07 4.21 1.52 6.35.07.33.03.65-.12.95-.97 1.88-.08 3.58 0 5.04.14 2.66.3 11.09 1.71 13.03.19.26.26.55.23.86-.39 3.3 1.28 5.05 2.32 7.41 1.19 2.71 2.75 5.04 4.68 6.99.73.74 1.31 1.42 1.72 2.05.18.27.41.48.7.63l4.58 2.33c1.55 2.7 2.61 4.94 2.66 8.29.06 4.12-.19 13.72 5.72 14.31.33.03.65-.04.93-.2 2.29-1.37 4.77-1.91 7.42-1.64.28.03.57-.04.81-.21.76-.53 1.58-.75 2.47-.68.36.03.54.23.54.59-.01 1.35-.53 2.42-1.56 3.19-.29.21-.47.5-.55.85l-1.68 7.79c-.06.3-.2.56-.43.78-.87.85-1.8 1.35-2.79 1.5-3.5-1.8-6.6-3.99-9.31-6.56-.25-.24-.52-.28-.81-.11l-1.21.69a66.974 66.974 0 0 1-13.12 5.39c-7.19 2.08-13.52 5.64-19 10.67-.24.22-.37.53-.37.86-.01 4.65-5.39 6.56-9.18 6.15-.78-.09-1.12.95-.44 1.35l3.54 2.06c.29.17.6.26.93.28 10.61.59 23.01-.48 31.28 6.7.37.33.56.24.57-.25.01-1.3.34-2.47.97-3.5.29-.47.62-.67.98-.59.37.08.73.38 1.1.9a29.85 29.85 0 0 1-1.77 9.55l-2.83 3.96c-.2.28-.31.59-.33.94a15.18 15.18 0 0 1-2.15 6.8c-.17.29-.42.47-.75.54-1.58.37-2.37 2.97-3.25 4.18-.37.51.13 1.2.73.99 3.58-1.24 6.91-.87 9.93-1.7 7.72-2.14 13.36-4.62 20.58.5l.5.18c.29.1.52.03.7-.22 3.15-4.27 3.43-6.87 9.13-8.47.3-.09.57-.24.8-.46 1.47-1.38 3.86-3.2 7.17-5.46 3.15-2.16 6.94-7.82 11.12-9.73 3.75-1.71 7.14-3.94 10.18-6.69 1.18-1.07 1.8-2.86 4.02-3.4.32-.08.59-.23.81-.46 2.02-2.07 4.32-2.33 6.3-4.52 1.03-1.14 2-1.98 2.89-2.53 5.35-3.32 9.59-8.5 15.58-11.18.29-.13.58-.14.87-.05l2.2.69c.54.17.59.9.09 1.15-3.49 1.69-6.14 3.26-8.1 6.91-4.07 7.57-11.13 10.23-17.99 14.08-.28.16-.48.44-.52.75l-.35 2.54c-14.33 9.29-29.6 19.19-41.16 31.87-.61.67-1.6.83-2.39.4-4.09-2.23-8.27-4.76-13.25-4.27-3.9.38-11.49 2.27-22.78 5.68-1.48.44-2.65.17-4.06.4-1.07.18-1.98-.77-1.77-1.83 1.96-9.77 9.49-14.27 12.4-22.84 1.13-1.38 1.48-2.96 1.03-4.75a.666.666 0 0 0-.81-.48c-1.37.33-2.52.06-3.46-.81-.27-.25-.6-.41-.97-.47a243.273 243.273 0 0 0-32.33-3.08c-1.17-.03-2.28-.37-3.31-1-.28-.17-.62-.22-.94-.16-2.01.43-3.89.13-5.65-.92-.35-.21-.49-.52-.4-.93l.72-3.39c.06-.27.03-.54-.08-.79l-.45-.95c2.29-.99 4.6-2.02 6.92-3.09 7.07-3.28 14.4-5.35 21.41-8.89 3.96-2 7.21-3.44 9.75-4.31 5.27-1.81 11.37-2.63 15.38-7.06.21-.23.32-.49.35-.8.59-5.86-4.88-8.24-7.32-11.64-4.76-6.64-7.77-12.66-10.06-20.94-1.39-5.05-2.68-10.13-3.86-15.24-.44-1.89-.62-4.06-.53-6.51.26-6.83-.85-12.45-5.07-17.51a74.973 74.973 0 0 1-7.38-10.6c-3.29-5.73-5.66-13.39-8.45-20.1-2.76-6.62-4.63-17.45-5.46-25.83-3.22-32.49-1.68-63.09 2.39-95.75.74-5.97 1.82-12.54 3.25-19.73 3.65-18.42 7.32-36.84 10.99-55.25.31-1.51-.27-3.55-.12-5.25.67-7.65 1.59-15.27 2.76-22.86.43-2.8 1.75-5.96 2.1-9.15.03-.31.2-.6.45-.79 1.2-.87 1.68-1.8 1.43-2.79 1.33-3.13 1.58-5.99.73-8.58 1.11-3.07 1.57-6.14 1.39-9.21Zm-8.52 87.72c-1.34 3.99-2.31 7.81-2.9 11.47-4.3 26.54-9.42 51.9-9.74 80.07-.09 7.96-.55 15.78-.72 23.68-.19 8.73 1.37 17.86 2.07 26.88.16 2.04 1.19 4.1 1.22 6.37-.31 6.91 3.5 13.8 6.62 20.77 1.17 2.59 2.52 4.75 4.06 6.48l3.17 5.57c.17.3.26.28.28-.07.33-6.46.1-12.85-.67-19.16-1.74-14.19-.81-29.27-.79-43.56l.68-6.06c.01-.15-.05-.22-.2-.22h-.29a.447.447 0 0 0-.46.39c-.37 2.49-1.72 4.16-4.05 5-.39-5.85-.21-11.63.52-17.32 1.96-15.34 1.16-31.69 1.39-47.19.27-17.82 4.91-34.19 2.49-52.26.24-2.07-.05-4.2-.88-6.39a.44.44 0 0 0-.79-.07c-1.31 2.17-1.64 4.05-1.01 5.62Zm14.15 21.93-.9-.07a.142.142 0 0 0-.16.14l-.18 2.21c-.84 10.46-1.27 18.97-.95 18.99h.04c.32.03 1.26-8.43 2.11-18.9l.17-2.21a.146.146 0 0 0-.13-.16Z"
      style={{
        fill: "#1a0d20",
      }}
    />
    <path
      d="M438.76 129.02c-.2 4.19-.03 8.35.5 12.49.52 4.08 0 9.09 1.75 13.51-.23 2.06-.2 4.28.08 6.67.85 7.3 1.07 15.72 2.94 23.8.86 3.71 1.49 7.88 1.89 12.52 1.05 12.11 1.99 24.31 2.82 36.59l1.44 18.17c.03.33.16.61.41.84.45.41.67.8.65 1.15-.58 10.21.09 20.72.2 30.91 0 .16.11.29.27.33.1.02.19.05.27.08v.01c.09 13.12.16 26.24.21 39.37 0 .37.12.69.36.98.57.67 1.29.94 2.18.8.32-.05.65.12.79.43.97 2.14.63 4.3-1.04 6.48-2.4 5.31-2.57 9.75-.88 15.71 2.29 8.03 4.78 15.9 6 24.11.97 6.49 1.82 12.99 2.56 19.51.91 8.07.59 16.35 1.22 24.52.15 1.96 1.08 3.77 1.52 5.79 3.53 21.74 4.3 42.54 4.57 65.02.03 2.49.99 5.6.88 7.69-.27 5.01-.35 10.01-.25 15.01.09 4.92 1.6 10.5 1.89 15.85-.36 2.78-.32 5.77.11 8.98.36 2.68-.4 3.05-2.27 1.1a15.803 15.803 0 0 0-3.8-2.92c-.33-.18-.57-.45-.71-.81-.99-2.6-2.51-4.84-4.56-6.73-.22-.21-.35-.46-.39-.76-.31-2.68-1.31-5.04-3-7.09-4.79-5.82-10.86-11.08-15.12-16.5-11.91-15.14-23.44-33.51-28.18-52.43-5.49-23.09-7.89-45.36-10.5-67.77-.88-7.59-1.38-14.23-1.49-19.93-.65-32.26 4.38-64.62-.31-96.7-.92-8.57-4.36-15.19-6.53-23.24-4.16-15.5-14.73-40.05-30.27-46.93l-5.06-4.43c2.72-1.49 4.58-3.31 5.59-5.45 7.49-15.95-6.17-22.61-17.71-29.97-7.77-4.97-15.35-11.08-23.25-16.41-8.78-5.93-10.42-13.49-23.11-13.5-6.76 0-17.14-.98-23.05 2.62-8.87 5.4-17.31 11.28-25.32 17.65l-5.96 5.39c-.27.24-.58.32-.93.23-.68-.17-1.3-.06-1.87.31-.89.59-2.08-.03-2.1-1.1-.01-.97-.31-1.81-.88-2.52l.39-23c0-.5.53-.82.98-.6 1.55.76 3.23.95 5.03.56.29-.06.58.02.79.23l.42.42c.25.26.56.35.92.28 8.89-1.88 18.18-3.63 23.07-11.22.89-1.39 1.34-3.64 2.33-5.32.16-.27.41-.49.7-.62 5.23-2.37 8.11-9.74 3.12-13.74q-.88-.97-2.57-2.53c-7.01-3.81-14.59-5.03-22.76-3.66-1.07.18-1.96.08-2.65-.29 1.23-9.4 2.28-16.74 7.56-24.21l4.56-5.13c2.9-3.61 4.37-5.11 8.25-7.94 7.73-6.22 15.98-11.14 24.73-15.23 6.75-3.16 12.37-6.02 16.84-8.57.27-.16.57-.24.9-.23 17.06.17 34.06.16 50.98 2.82 3.95.62 6.53-.31 9.04-3.09.23-.25.5-.33.83-.25 11.43 2.85 23.45 6.7 32.48 14.59 8.78 7.68 15.76 16.01 19.65 28.15 6.15 19.21 10.1 38.92 11.84 59.15Zm-34.22-2.51s18.83-14.05 6.18-22.24c-11.84-7.66-22.08-7.42-35.42-9.16-7.49-.98-13.87 2.37-19.87 6.86-9.65 7.23-4.62 17.42 4.81 20.82 11.07 4 44.52 3.75 44.3 3.72Z"
      style={{
        fill: "#9f87a5",
      }}
    />
    <path
      d="M253.23 154.4c-1.27 2.79-3.18 5.35-5.73 7.66-1.05-1.51-1.63-3.28-1.73-5.31-.04-.89.62-1.65 1.5-1.74l5.96-.61ZM272.81 260.5c2.1-.3 4.24-.06 6.43.71l-6.77-.08c.02-.22.13-.43.34-.63ZM243.06 356.78l.33-7.69-.33 7.69ZM232.6 360.12c2.42 18.07-2.22 34.44-2.49 52.26-.23 15.5.57 31.85-1.39 47.19-.73 5.69-.91 11.47-.52 17.32l-.38 2.56c-.05.37.39.59.65.33l3.36-3.32c.25-.25.45-.22.58.11.13.32.17.72.11 1.21-.02 14.29-.95 29.37.79 43.56.77 6.31 1 12.7.67 19.16-.02.35-.11.37-.28.07l-3.17-5.57c-4.2-8.95-8.3-17.58-10.68-27.25-.03-2.27-1.06-4.33-1.22-6.37-.7-9.02-2.26-18.15-2.07-26.88.17-7.9.63-15.72.72-23.68.32-28.17 5.44-53.53 9.74-80.07.59-3.66 1.56-7.48 2.9-11.47.33 6.31.6 12.46.81 18.47.01.16.06.28.17.35.23.15.36.09.39-.19l1.31-17.79ZM492.71 599.46c.22.06.37.07.44.02.32.29.4.6.24.95-2.25 4.93-5.46 4.12-9.59 4.91-1.34.25-2.7.35-4.07.29a1.62 1.62 0 0 1-.89-.33c-1.76-1.35-5.73-.07-8.63-1.68 2.26.18 4.36.93 6.42.82 6.09-.33 12.76 1.64 16.08-4.98ZM275.56 638.83c.25.29.41.59.48.88-10.79 2.52-21.09 6.24-31.83 8.73-2.87.67-5.81 1.72-8.81 3.13.75-.32.7-.4-.13-.25 1.17-2.2 2.91-3.75 5.31-4 .44-.05.77-.25 1-.6.17-.27.4-.45.7-.56.99-.34 2.04-.29 2.93-.73 4.61-2.33 9.46-3.95 14.55-4.86 1.37-.24 3.07-1.58 5.09-4.02.21-.25.25-.52.1-.81-.51-1.05-.75-2.01-.72-2.89l1.21-.69c.29-.17.56-.13.81.11 2.71 2.57 5.81 4.76 9.31 6.56ZM259.72 672.42c-.19 2.52-.91 4.8-2.16 6.83-.41.68.25 1.49 1 1.24 3.4-1.16 6.79-2.11 10.18-2.84 5.21-1.12 12.13-1.48 18.22-2.57 2.26-.41 5.36.32 7.2-.94-.53 2.34-1.84 3.59-3.91 3.75-.35.03-.65.17-.9.42-1.35 1.38-3.12 1.8-4.2 3.21a14.195 14.195 0 0 0-2.34 4.62c-.09.31-.11.62-.06.93.13.77-.23 1.29-1.1 1.56-7.22-5.12-12.86-2.64-20.58-.5-3.02.83-6.35.46-9.93 1.7-.6.21-1.1-.48-.73-.99.88-1.21 1.67-3.81 3.25-4.18.33-.07.58-.25.75-.54a15.18 15.18 0 0 0 2.15-6.8c.02-.35.13-.66.33-.94l2.83-3.96Z"
      style={{
        fill: "#9f87a5",
      }}
    />
    <path
      d="M258.66 64.75c-5.28 7.47-6.33 14.81-7.56 24.21l-5.15.57c-.43.05-.61-.14-.53-.57.47-2.65 1.26-5.13 2.38-7.42 2.81-5.75 5.83-12.63 10.86-16.79ZM253.07 146.14c-1.47 2.27-2.34 4.47-2.61 6.59-.05.37.08.65.38.86.56.39 1.36.66 2.39.81l-5.96.61c-.88.09-1.54.85-1.5 1.74.1 2.03.68 3.8 1.73 5.31.2 1.03-.39 1.9-1.77 2.59-.3.15-.66-.05-.69-.38-.27-3.12-.84-5.79-1.71-8.01-1.08-2.75-3.18-4.05-2-7.81.57.71.87 1.55.88 2.52a1.351 1.351 0 0 0 2.1 1.1c.57-.37 1.19-.48 1.87-.31.35.09.66.01.93-.23l5.96-5.39ZM441.01 155.02c.07-.08.15-.16.23-.24 1.01 5.89 2.3 11.52 3.86 16.89.34 1.18.74 1.78 1.19 1.81 1.58.09 2.83 1.35 2.92 2.93.23 4.25.44 8.57.61 12.94.27 6.82 1.64 14.94 1.72 22.53.04 4.39-2.8 9.25-2.54 12.61.26 3.32.17 6.69-.26 10.11-.83-12.28-1.77-24.48-2.82-36.59-.4-4.64-1.03-8.81-1.89-12.52-1.87-8.08-2.09-16.5-2.94-23.8-.28-2.39-.31-4.61-.08-6.67ZM359.92 191.2l5.06 4.43c2.69 3.75 5.6 7.14 8.73 10.16 10.49 10.14 16.37 24.01 20.22 37.83 2.27 8.13 5.05 14.75 7.85 22.18 4.69 32.08-.34 64.44.31 96.7.11 5.7.61 12.34 1.49 19.93 2.61 22.41 5.01 44.68 10.5 67.77-.49 4.49.34 9.01 2.48 13.58 4.64 9.9 8.31 17.44 11.02 22.61.08.17.22.31.4.4 1.19.61 1.69 1.6 1.5 2.97-.05.39.06.73.33 1.01 7.38 7.55 12 12.74 13.86 15.56 2.37 3.61 4.07 6.01 5.1 7.18.16.18.28.41.33.65 1.04 4.94 5.86 9.53 8.83 13.51.18.24.41.42.69.53 2.49 1.01 6.65 7.46 8.16 9.85.15.25.37.42.64.53 2.35.88.78 4.82-.43 5.99-.24.23-.4.51-.47.84l-.87 3.62c-.96-.7-2.21-1.62-3.42-1.46-1.76.23-2.26 1.61-1.98 3.2.12.71-.04 1.21-.49 1.5l-.77-5.33c0-2.41-1.47-4.18-4.37-5.32a201.66 201.66 0 0 0-13.08-13.74c-3.23-3.09-5.6-6.69-8.31-10.18-7.03-9.05-13.48-21.41-17.33-30.13-2.31-5.23-3.78-9.09-4.41-11.57-7.82-30.75-11.12-61.79-14.48-93.25-.98-9.15-1.22-22.17-.72-39.07.49-16.23 1.14-32.46 1.97-48.68.88-17.3-4.27-35.42-10.35-52.18-3.5-9.65-7.24-16.25-14.32-24.59-3.83-4.52-7.45-9.13-10.85-13.83-2.25-3.99-3.97-8.07-5.17-12.23l2.35-.97Zm62.76 304.62c.38.43.58.93.6 1.48.01.31.1.62.26.89 4.25 6.93 6.5 14.05 12.73 20.79.22.24.44.79.65 1.65.07.31.26.5.56.59.88.25 1.42.85 1.61 1.78.06.31.21.56.46.76l4.7 3.71c.27.21.47.47.61.78.25.55.65.95 1.21 1.18.52.22.6.12.23-.31-.69-.81-1.06-1.74-1.1-2.78-.01-.33-.13-.62-.35-.87-2.15-2.45-3.74-5.2-4.78-8.25-2.96-8.69-11.18-13.42-14.8-21.4-2.14-4.71-3.8-10.22-6.43-14.61-1.1-1.83-2.08-3.32-2.94-4.45-1.53-2.03-1.92-1.83-1.17.6 2.02 6.53 3.37 13.21 7.95 18.46ZM259.03 257.65l-1.55.28c-1.86-.83-3.7-.92-5.53-.27l-9.88-1.57c1.25-1.64 2.98-2.17 5.2-1.6 5.29 1.37 8.97 2.21 11.06 2.54.21.03.36.14.45.32.06.12.14.22.25.3ZM243.07 281.36c.24-.05.46-.08.66-.1.31-.03.47.11.49.42l1.12 14.22c.03.5.3.71.8.64l1.51-.23c.66-.1 1.15.6.83 1.19-2.61 4.71-4.28 9.75-5.03 15.12-.11.78.65 1.4 1.39 1.14l1.46-.5c.59-.2 1.13.42.84.97-2.34 4.53-1.79 11.34-1.53 16.33-2.25 6.53-2.99 12.71-2.22 18.53l-.33 7.69.07 4.47c.24 1.75.03 3.69-.63 5.82l-.62-6.78c-.04-.38-.21-.68-.52-.9-1.03-.72-1.37-1.76-1.03-3.11a.646.646 0 0 0-.7-.8l-1.31.13c-.26.03-.44-.08-.55-.32-.47-1.03-.49-2.1-.08-3.21.11-.31.13-.62.06-.94-.98-3.97-1.44-7.33-1.37-10.07.17-6.7-.63-14.42.74-20.92.63-3 1.58-5.94 1.9-8.91a545.59 545.59 0 0 1 4.05-29.88ZM454.49 334.15c.23 7.7 1.13 15.3 2.68 22.79.13.62.67 1.06 1.3 1.06h3.78c.4 0 .73.32.75.72.11 3.51.3 7.02.55 10.52.71 9.67-.41 19.39.08 29.16.1 2.03.93 5.16.93 7.83 0 5.86.48 11.66.35 17.56-.44-2.02-1.37-3.83-1.52-5.79-.63-8.17-.31-16.45-1.22-24.52a556.48 556.48 0 0 0-2.56-19.51c-1.22-8.21-3.71-16.08-6-24.11-1.69-5.96-1.52-10.4.88-15.71ZM232.6 360.12l-1.31 17.79c-.03.28-.16.34-.39.19-.11-.07-.16-.19-.17-.35-.21-6.01-.48-12.16-.81-18.47-.63-1.57-.3-3.45 1.01-5.62a.44.44 0 0 1 .79.07c.83 2.19 1.12 4.32.88 6.39ZM461.57 569.4c2.47 1.57 4.95 2.29 7.42 2.16.33-.02.61.09.84.32 2.61 2.62 5.49 4.34 8.64 5.15.73.19 1.2.56 1.39 1.11.1.29.28.51.55.65 2.31 1.26 4.61 2.55 6.9 3.87 1.46.85 2.63.79 3.29 2.82.1.31.29.56.56.74 1.66 1.1 3.34 1.39 4.49 3.02 1.59 2.25 2.34 4.78 2.24 7.59-.01.33.06.65.22.94.44.77.31 1.49-.39 2.15-.23.22-.32.54-.24.84.85 3.33-.57 5.95-4.11 6.6-9.08 1.68-17.93.39-26.81-.11-3.23-.19-5.44-.08-6.61.32-2.61.89-4 2.94-4.17 6.16-.42 7.99-.82 9.08-6.33 14.44-1.42 1.38-2.64 2.49-3.53 3.22l-5.95 4.87c-.67.55-1.69.14-1.78-.73-.47-4.59-.7-10.75-3.19-14.56-.2-.29-.5-.5-.85-.57-3.32-.69-6.54-.47-9.67.66-8.06 1.03-15.98 1.28-23.76.74-.15-.01-.23-.1-.22-.25.01-.09.01-.17 0-.25 14.96-.86 27.85.59 40.25-8.58 3.51-2.59 6.81-5.28 11.09-6.4 6.21-1.63 12.34-2.53 18.37-2.7 2.9 1.61 6.87.33 8.63 1.68.27.2.56.31.89.33 1.37.06 2.73-.04 4.07-.29 4.13-.79 7.34.02 9.59-4.91.16-.35.08-.66-.24-.95 1.83-5.76-1.57-9.43-6.38-11.77-.6-.29-1.05-.67-1.34-1.13-.16-.25-.39-.43-.68-.52-1.53-.46-2.38-1.46-2.56-3.01a.914.914 0 0 0-.39-.66c-2.49-1.73-4.31-3.4-7.08-5.01-1.15-.67-2.25-1.39-3.32-2.17-.25-.19-.54-.29-.85-.32-3.83-.35-6.82-2.18-8.98-5.49Z"
      style={{
        fill: "#312339",
      }}
    />
    <path
      d="M262.02 604.26c3.79 2.28 6.98 7.06 11.6 7.73 7.87 6.21 14.81 6.76 24.81 5.96 16.05-1.28 32.54-.39 48.66-.45 6.87-.02 13.76.44 20.65.75 1.81.08 3.61 1.31 5.4 1.44 5.54.4 11.07.17 16.49 1.59 2.59.68 5.19.83 7.82.45-.25.74-.12 1.21.38 1.41 4.17 1.7 14.16.31 18.93.05-.22.31-.56.51-1.01.6-.27.05-.29.15-.05.3l.34.2c.2.12.34.07.42-.16l.11-.35c.09-.28.48-.28.58 0 .83 2.37 1.19 4.79 1.08 7.27-.12 2.54-1.7 5.99-1.45 8.68.08.86.52 1.23 1.32 1.12.25-.03.43.07.53.31.11.25.38.54.81.86-4.97.73-10.14.79-15.5.2-.32-.03-.6-.16-.83-.38-3.27-3.02-7.62-1.11-11.55-3.57-.28-.17-.58-.26-.91-.26l-3.96-.05 1.39-.97c.35-.24.4-.54.17-.9l-2.69-4.05a.56.56 0 0 0-.62-.22l-9.67 3.16c-.7.23-.8 1.17-.16 1.54l3.02 1.73c.29.17.44.42.47.75.15 2.29-.34 4.03-1.48 5.21-.45-1.53-.46-3.17-.04-4.9a.557.557 0 0 0-.44-.69c-2.26-.46-4.22-1.19-6.52-1.12-5.11.17-10.06.48-14.85.94-1.39.14-2.63.89-3.39 2.05-5.09 7.77-7.96 12.72-16.79 16.9-2.75 1.3-5.43 2.76-8.04 4.37l.35-2.54c.04-.31.24-.59.52-.75 6.86-3.85 13.92-6.51 17.99-14.08 1.96-3.65 4.61-5.22 8.1-6.91a.62.62 0 0 0-.09-1.15l-2.2-.69c-.29-.09-.58-.08-.87.05-5.99 2.68-10.23 7.86-15.58 11.18-.89.55-1.86 1.39-2.89 2.53-1.98 2.19-4.28 2.45-6.3 4.52-.22.23-.49.38-.81.46-2.22.54-2.84 2.33-4.02 3.4a39.522 39.522 0 0 1-10.18 6.69c-4.18 1.91-7.97 7.57-11.12 9.73-3.31 2.26-5.7 4.08-7.17 5.46-.23.22-.5.37-.8.46-5.7 1.6-5.98 4.2-9.13 8.47-.18.25-.41.32-.7.22l-.5-.18c.87-.27 1.23-.79 1.1-1.56-.05-.31-.03-.62.06-.93.5-1.69 1.28-3.23 2.34-4.62 1.08-1.41 2.85-1.83 4.2-3.21.25-.25.55-.39.9-.42 2.07-.16 3.38-1.41 3.91-3.75 5.57-6.7 13.53-12.71 20.37-18.1 6.7-5.27 14.68-9.71 22.21-14.33 1.01-.62 2.13-.92 3.22-1.52.55.02 1.09-.09 1.62-.33.32-.15.46-.4.41-.75l-.04-.31c-.03-.24.06-.41.29-.52l3.48-1.55c.17-.07.16-.12-.02-.14-10.45-1.22-20.36-.51-29.75 2.12-5.02 2.91-9.02 4.57-11.99 5-3.94.57-10.04.59-18.31.08-3.82-.23-6.55-2.12-9.61-4.08-.07-.29-.23-.59-.48-.88.99-.15 1.92-.65 2.79-1.5.23-.22.37-.48.43-.78l1.68-7.79c.08-.35.26-.64.55-.85 1.03-.77 1.55-1.84 1.56-3.19 0-.36-.18-.56-.54-.59-.89-.07-1.71.15-2.47.68-.24.17-.53.24-.81.21-2.65-.27-5.13.27-7.42 1.64-.28.16-.6.23-.93.2-5.91-.59-5.66-10.19-5.72-14.31-.05-3.35-1.11-5.59-2.66-8.29Zm22.41 23.66c-.99 2.89 3.26 4.23 4.53 6.55.39.71 1.13 1.16 1.95 1.17l12.96.15a.8.8 0 0 0 .71-1.19l-.99-1.75c-.18-.32-.45-.53-.8-.64-3.39-1.02-5.57-3.36-8.7-4.23a58.68 58.68 0 0 0-7.27-1.52c-1.04-.15-2.05.46-2.39 1.46ZM251.11 638.24c-3.55 1.91-6.59 4.49-9.94 6.57-2.71 1.69-6.42 1.59-5.9 6.51.83-.15.88-.07.13.25 9.45-.12 17.96 2.13 25.54 6.74.29.18.49.58.6 1.21v1.96l-.05 1.39c-.37-.52-.73-.82-1.1-.9-.36-.08-.69.12-.98.59-.63 1.03-.96 2.2-.97 3.5-.01.49-.2.58-.57.25-8.27-7.18-20.67-6.11-31.28-6.7-.33-.02-.64-.11-.93-.28l-3.54-2.06c-.68-.4-.34-1.44.44-1.35 3.79.41 9.17-1.5 9.18-6.15 0-.33.13-.64.37-.86 5.48-5.03 11.81-8.59 19-10.67Z"
      style={{
        fill: "#312339",
      }}
    />
    <path
      d="m207.39 653.44.45.95c.11.25.14.52.08.79l-.72 3.39c-.09.41.05.72.4.93 1.76 1.05 3.64 1.35 5.65.92.32-.06.66-.01.94.16 1.03.63 2.14.97 3.31 1 10.85.31 21.62 1.33 32.33 3.08.37.06.7.22.97.47.94.87 2.09 1.14 3.46.81.35-.09.72.12.81.48.45 1.79.1 3.37-1.03 4.75-1.87-2.57-4.49-4.06-7.87-4.48-9.31-1.16-18.63-2.16-27.97-3-3.56-.32-21.83-1.99-10.81-10.25ZM438.82 665.75c-.83 5.79-1.5 11.87-3.58 17.12a64.066 64.066 0 0 1-5.08 10.1c-.17.27-.4.36-.7.26-2.8-.88-5.45-1.56-8.3-.12-3.95 2-7.71 3.45-11.48 6.13-3.12 2.22-10.8 7.38-14.7 5.8-1.33-.53-2.7-1.42-4.12-2.67 1.91.01 3.51.34 4.8.99.28.14.6.18.9.1 1.56-.4 3.08-.86 4.57-1.37 3.59-1.25 6.74-4.4 9.68-6.77 1.35-1.09 3.09-1.17 4.5-2.02 3.45-2.08 5.88-3.56 10.04-3.77 2.25-.11 4.3-.82 6.17-2.14.28-.2.48-.47.59-.8 1.5-4.34 3.36-8.27 3.81-12.97.27-2.77 1.23-5.4 2.9-7.87Z"
      style={{
        fill: "#312339",
      }}
    />
    <path
      d="m337.5 17.36-5.37.95c-.06.01-.11.04-.15.08-.15.16-.33.3-.55.42-.17.09-.36.15-.55.17-2.67.27-5.33.19-7.96-.23-4.21-.68-11.41-.37-15.22 1.53-4.56 2.29-9.17 3.16-13.94 5.18-1.75.75-3.54 1.25-5.39 1.5 4.76-2.91 9.93-5.2 15.52-6.87.35-.11 1.58-.59 3.69-1.44 1.72-.7 3.47-.73 5.17-1.42 4.73-1.93 7.94-.05 12.2.01 4.19.05 8.37.09 12.55.12Z"
      style={{
        fill: "#5c4e65",
      }}
    />
    <rect
      width={15.5}
      height={2.38}
      x={291.52}
      y={26.41}
      rx={1.13}
      ry={1.13}
      style={{
        fill: "#5c4e65",
      }}
      transform="rotate(-17.9 299.273 27.611)"
    />
    <path
      d="M413.03 42.46c2.3 1.51 3.79 3.6 4.48 6.28.08.3-.3.49-.5.25-1.62-1.94-3.28-3.81-4.98-5.61-.17-.17-.26-.34-.28-.5-.04-.28.11-.42.46-.43.44-.01.79-.01.82 0ZM262.37 48.06c-6.83 6.9-12.62 14.72-17.39 23.47 2.92-10.18 8.01-18.41 17.39-23.47ZM447.88 126.72c1.16 5.94 1.37 12.05.62 18.32-1.29-5.78-1.49-11.89-.62-18.32ZM438.76 129.02c1.77 8.51 2.6 17.09 2.48 25.76-.08.08-.16.16-.23.24-1.75-4.42-1.23-9.43-1.75-13.51-.53-4.14-.7-8.3-.5-12.49ZM232.89 169c.14.17.15.35.02.54-.14.21-.45.19-.57-.03-1.49-2.71-1.14-4.78 1.07-6.21.9-.58 2.06.18 1.89 1.24-.27 1.69-1.05 2.97-2.34 3.86-.25.17-.27.37-.07.6ZM247.9 165.43l.45 1.07c-6.82 6.76-8.95 11.91-13.26 18.8a76.69 76.69 0 0 1 2.73-8.76c1.66-4.36 6.66-8.03 10.08-11.11ZM364.98 195.63c15.54 6.88 26.11 31.43 30.27 46.93 2.17 8.05 5.61 14.67 6.53 23.24-2.8-7.43-5.58-14.05-7.85-22.18-3.85-13.82-9.73-27.69-20.22-37.83-3.13-3.02-6.04-6.41-8.73-10.16ZM235.35 270.67c.84-.11 1.87.19 3.09.89.18 3.07-.28 6.14-1.39 9.21l-2.16-5.84c.94-1.53 1.09-2.95.46-4.26ZM271.17 274.08c-3.45 5.91-8.32 8.39-12.17 13.35-2.51 2.99-4.07 6.42-4.68 10.29-.76 4.78-4.08 8.49-5.25 13.36a165.76 165.76 0 0 0-3.46 19.48c-.26-4.99-.81-11.8 1.53-16.33.29-.55-.25-1.17-.84-.97l-1.46.5c-.74.26-1.5-.36-1.39-1.14.75-5.37 2.42-10.41 5.03-15.12a.81.81 0 0 0-.83-1.19l-1.51.23c-.5.07-.77-.14-.8-.64l-1.12-14.22c-.02-.31-.18-.45-.49-.42-.2.02-.42.05-.66.1l-3.44-4.82c-.17-.23-.22-.49-.17-.78l.78-4.08 7.61.78c4.32 1.18 8.33 1 12.69 1.92 3.65.77 6.91-.19 9.77-2.89.31-.29.81-.03.74.39a4.8 4.8 0 0 0 .12 2.2ZM463.95 316.5c1.59 3.37.72 5.56 1.25 8.71.85 5.02.29 9.78.91 14.81.91 7.39 1.21 14.82.9 22.3-.53-1.63-1.09-4.68-1.7-9.13-1.8-13.29-2.25-25.52-1.36-36.69ZM414.08 450.2c4.74 18.92 16.27 37.29 28.18 52.43 4.26 5.42 10.33 10.68 15.12 16.5 1.69 2.05 2.69 4.41 3 7.09.04.3.17.55.39.76 2.05 1.89 3.57 4.13 4.56 6.73.14.36.38.63.71.81 1.39.76 2.65 1.73 3.8 2.92 1.87 1.95 2.63 1.58 2.27-1.1-.43-3.21-.47-6.2-.11-8.98 1.19 4.99 1.97 10.84 2.34 17.57.18 3.19.22 5.72.13 7.61-.02.45-.23.58-.64.39l-8.18-3.9.87-3.62c.07-.33.23-.61.47-.84 1.21-1.17 2.78-5.11.43-5.99-.27-.11-.49-.28-.64-.53-1.51-2.39-5.67-8.84-8.16-9.85a1.57 1.57 0 0 1-.69-.53c-2.97-3.98-7.79-8.57-8.83-13.51-.05-.24-.17-.47-.33-.65-1.03-1.17-2.73-3.57-5.1-7.18-1.86-2.82-6.48-8.01-13.86-15.56-.27-.28-.38-.62-.33-1.01.19-1.37-.31-2.36-1.5-2.97a.862.862 0 0 1-.4-.4c-2.71-5.17-6.38-12.71-11.02-22.61-2.14-4.57-2.97-9.09-2.48-13.58ZM232.52 477.78c.06-.49.02-.89-.11-1.21-.13-.33-.33-.36-.58-.11l-3.36 3.32c-.26.26-.7.04-.65-.33l.38-2.56c2.33-.84 3.68-2.51 4.05-5 .03-.23.23-.4.46-.39h.29c.15 0 .21.07.2.22l-.68 6.06ZM422.68 495.82c-4.58-5.25-5.93-11.93-7.95-18.46-.75-2.43-.36-2.63 1.17-.6.86 1.13 1.84 2.62 2.94 4.45 2.63 4.39 4.29 9.9 6.43 14.61 3.62 7.98 11.84 12.71 14.8 21.4 1.04 3.05 2.63 5.8 4.78 8.25.22.25.34.54.35.87.04 1.04.41 1.97 1.1 2.78.37.43.29.53-.23.31a2.22 2.22 0 0 1-1.21-1.18c-.14-.31-.34-.57-.61-.78l-4.7-3.71c-.25-.2-.4-.45-.46-.76-.19-.93-.73-1.53-1.61-1.78-.3-.09-.49-.28-.56-.59-.21-.86-.43-1.41-.65-1.65-6.23-6.74-8.48-13.86-12.73-20.79-.16-.27-.25-.58-.26-.89-.02-.55-.22-1.05-.6-1.48ZM219.85 507.75c2.38 9.67 6.48 18.3 10.68 27.25-1.54-1.73-2.89-3.89-4.06-6.48-3.12-6.97-6.93-13.86-6.62-20.77ZM245.45 531.61c0 2.99.62 5.46-.4 8.48-1.86 5.47-.91 9.91.14 16.24.57 3.43 1.95 6.67 2.46 9.95 1.07 6.87 2.71 13.6 4.9 20.2 3.47 10.44 12.22 19.07 21.07 25.51-4.62-.67-7.81-5.45-11.6-7.73l-4.58-2.33c-.29-.15-.52-.36-.7-.63-.41-.63-.99-1.31-1.72-2.05-1.93-1.95-3.49-4.28-4.68-6.99-1.04-2.36-2.71-4.11-2.32-7.41.03-.31-.04-.6-.23-.86-1.41-1.94-1.57-10.37-1.71-13.03-.08-1.46-.97-3.16 0-5.04.15-.3.19-.62.12-.95-.45-2.14-.95-4.26-1.52-6.35-1.18-4.37-1.14-8.98-2.14-13.47-.89-4.03-2.97-13.4-1.35-16.81 1.04-2.2.55-8.39.89-8.83.07-.09.16-.16.25-.19.23-.09.36-.01.39.24.32 2.99 1.31 6.63.74 9.56-.41 2.12.25 2.95 1.99 2.49ZM288.96 634.47c-1.27-2.32-5.52-3.66-4.53-6.55.34-1 1.35-1.61 2.39-1.46 2.45.35 4.87.86 7.27 1.52 3.13.87 5.31 3.21 8.7 4.23.35.11.62.32.8.64l.99 1.75a.8.8 0 0 1-.71 1.19l-12.96-.15c-.82-.01-1.56-.46-1.95-1.17ZM264.23 632.85c-.03.88.21 1.84.72 2.89.15.29.11.56-.1.81-2.02 2.44-3.72 3.78-5.09 4.02-5.09.91-9.94 2.53-14.55 4.86-.89.44-1.94.39-2.93.73-.3.11-.53.29-.7.56-.23.35-.56.55-1 .6-2.4.25-4.14 1.8-5.31 4-.52-4.92 3.19-4.82 5.9-6.51 3.35-2.08 6.39-4.66 9.94-6.57 4.54-1.32 8.91-3.12 13.12-5.39ZM421.03 677.79c.38 1.06-.18 1.81-1.68 2.26-2.27.68-4.04 2.04-6.34 2.71-.31.09-.6.26-.83.5-2.87 2.95-7.32 7.06-11.39 6.87-.31-.01-.62.05-.91.18-5.37 2.48-5.83-5.17-5.54-8.93l2.23 7.23c.12.38.46.65.86.68l3.21.25c.4.03.76-.07 1.09-.3 6.37-4.55 12.8-8.37 19.3-11.45Z"
      style={{
        fill: "#5c4e65",
      }}
    />
    <path
      d="M236.32 289.35c.25.99-.23 1.92-1.43 2.79-.25.19-.42.48-.45.79-.35 3.19-1.67 6.35-2.1 9.15-1.17 7.59-2.09 15.21-2.76 22.86-.15 1.7.43 3.74.12 5.25-3.67 18.41-7.34 36.83-10.99 55.25-1.43 7.19-2.51 13.76-3.25 19.73-4.07 32.66-5.61 63.26-2.39 95.75.83 8.38 2.7 19.21 5.46 25.83 2.79 6.71 5.16 14.37 8.45 20.1 2.15 3.74 4.61 7.27 7.38 10.6 4.22 5.06 5.33 10.68 5.07 17.51-.09 2.45.09 4.62.53 6.51 1.18 5.11 2.47 10.19 3.86 15.24 2.29 8.28 5.3 14.3 10.06 20.94 2.44 3.4 7.91 5.78 7.32 11.64-.03.31-.14.57-.35.8-4.01 4.43-10.11 5.25-15.38 7.06-2.54.87-5.79 2.31-9.75 4.31-7.01 3.54-14.34 5.61-21.41 8.89-2.32 1.07-4.63 2.1-6.92 3.09-11.02 8.26 7.25 9.93 10.81 10.25 9.34.84 18.66 1.84 27.97 3 3.38.42 6 1.91 7.87 4.48-2.91 8.57-10.44 13.07-12.4 22.84-.21 1.06.7 2.01 1.77 1.83 1.41-.23 2.58.04 4.06-.4 11.29-3.41 18.88-5.3 22.78-5.68 4.98-.49 9.16 2.04 13.25 4.27.79.43 1.78.27 2.39-.4 11.56-12.68 26.83-22.58 41.16-31.87 2.61-1.61 5.29-3.07 8.04-4.37 8.83-4.18 11.7-9.13 16.79-16.9.76-1.16 2-1.91 3.39-2.05 4.79-.46 9.74-.77 14.85-.94 2.3-.07 4.26.66 6.52 1.12.32.06.52.37.44.69-.42 1.73-.41 3.37.04 4.9-.82 1.3-1.17 2.97-1.99 4.26-7.39 11.55-14.06 21.58-16.27 35.28-.5 3.1-2.93 10.45-.47 12.83.73.71 1.49.76 2.3.13 7.38-5.74 15.43-13.91 24.04-16.9a1.66 1.66 0 0 1 2.19 1.4c.75 7.79 2.06 14.84 3.94 21.16 1.42 1.25 2.79 2.14 4.12 2.67 3.9 1.58 11.58-3.58 14.7-5.8 3.77-2.68 7.53-4.13 11.48-6.13 2.85-1.44 5.5-.76 8.3.12.3.1.53.01.7-.26 1.99-3.22 3.69-6.59 5.08-10.1 2.08-5.25 2.75-11.33 3.58-17.12.62-3.21 1.25-5.98.89-9.35-.47-4.53-.8-9.07-.99-13.62-.01-.31.05-.61.2-.88 1.81-3.37 3.85-5.81 6.14-7.32 4.09-2.72 13.4-8.3 15.23-12.8 5.95-14.67 19.84-5.51 30.34-9.25 8.71-3.11 11.01-6.7 12.2-15.8.58-4.5-.99-7.95-4.72-10.35-8.05-5.18-16.2-10.19-24.45-15.02-3.06-1.79-5.58-3.77-7.56-5.93-.19-.21-.31-.47-.34-.76l-1.07-9.47c-.17-1.5.48-2.08 1.95-1.75 2.5.57 7.71 3.47 10.4 2.1.3-.15.46-.4.49-.74 1.42-20.09 1.12-40.13-.89-60.13-1.23-12.27-1.89-18.9-1.97-19.89-1.46-17.27-2.61-34.7-4.61-51.91-.35-2.99-.43-6.62-.22-10.89.17-3.5-1.35-7.14-1.32-10.77.11-13.05-.39-26.02-1.51-38.9.31-7.48 0-14.91-.9-22.3-.62-5.03-.06-9.79-.91-14.81-.53-3.15.34-5.34-1.25-8.71-.27-3.37-.68-6.73-1.23-10.09-2.01-12.23-3.82-24.75-3.84-37.16-.02-16.11-.06-32.23-.11-48.34-.03-11.45-1.5-22.23-2.86-33.48-1.73-14.34-5.58-28.06-7.41-42.39.75-6.27.54-12.38-.62-18.32-.82-11.53-2.54-22.89-5.15-34.06-1.65-7.08-4.46-14.94-6.76-22.39-4.09-13.3-15.18-33.5-28.52-39.34-13.96-6.12-31.13-12.2-46.46-12.51-7.84-.16-15.67-.51-23.49-1.06-4.18-.03-8.36-.07-12.55-.12-4.26-.06-7.47-1.94-12.2-.01-1.7.69-3.45.72-5.17 1.42-2.11.85-3.34 1.33-3.69 1.44-5.59 1.67-10.76 3.96-15.52 6.87-2.54 2.45-5.99 3.92-8.43 5.83-6.24 4.85-12.35 9.14-17.57 15.27-9.38 5.06-14.47 13.29-17.39 23.47-2.84 4.67-5.16 9.76-6.96 15.25-1.88 5.75-8.82 8.86-13.03 12.95-4.37 4.26-3.68 11.3 1.04 15.04 2.21 1.75 4.31 3.63 6.31 5.62.21.21.46.33.75.34.25 0 .43.13.54.36 1 2.08 1.41 3.82 1.26 6.27-.47 7.84-1.09 15.67-1.85 23.49-.11 1.09-.96 3.33-1.67 4.13-4.88 5.45-7.22 10.09-7.68 16.78-.37 5.35 1.75 8.45-1.26 13.96-3.63 6.67-8.38 12.84-14.98 16.76a37.287 37.287 0 0 0-4.86 3.42c-3.72 3.08-6.54 7.99-9.85 11.83-5.57 6.46-10.38 13.2-14.43 20.23-2.09 3.61-4.11 6.07-4.15 10.48-.05 5.65 3.92 9.07 7.99 12.66 1.56 1.37 3.09 2.16 4.58 2.39.33.05.5.25.51.58v.49c-5.71-1.05-8.62-3.94-11.98-8.8-2.72-3.95-3.21-8.01-1.47-12.2 1.09-2.62 3.43-6.69 7.03-12.21 5.25-8.04 12.67-17.33 18.14-23.87 2.12-2.53 4.67-4.63 7.66-6.31 2.21-1.25 3.84-2.38 4.88-3.41 3.96-3.91 7.35-8.28 10.16-13.11 1.56-2.67.83-10.19 1.03-13.55.48-7.76 3.5-13.35 8.81-18.59.31-.3.48-.66.51-1.09l1.86-25.56c.09-1.18-.33-2.35-1.15-3.2-3.01-3.13-9.32-7.27-10.9-11.29-5.46-13.94 11.85-15.64 15.43-25.26 4.27-11.49 9.6-27.1 18.3-35.93 8.95-9.09 18.4-20.35 30.53-25.1 12.28-4.8 22.42-8.16 30.41-10.08 2.31-.56 6.35.74 9.01.73 4.49-.03 8.97.2 13.44.68 3.41.37 7.34-.05 11.08.34 8.45.88 16.33-.2 24.75 1.88 10.97 2.71 21.67 6.22 32.1 10.52 12.78 5.27 24.21 24.08 28.57 36.58a582.51 582.51 0 0 1 8.2 25.41c1.84 6.19 3.15 12.18 3.94 17.99 1.64 12.21 2.52 24.48 2.63 36.81.12 11.97 4.41 24.02 6.12 35.79 2.23 15.29 3.56 26.86 4 34.71.66 11.69.72 26.96.17 45.82-.52 17.88 1.38 34.62 4.61 51.75.77 4.09 1.26 8.11 1.47 12.06.36 6.72.87 13.43 1.53 20.12.13 1.26-.13 4.32.45 6.28.31 1.03.45 1.9.44 2.62-.1 6.37.92 13.28.98 18.98.24 20.64 1.08 41.26 2.53 61.85 1.45 20.63 3.36 37.56 5.37 56.38 2.12 19.85 1.47 40.42 1.13 60.37-.13 7.53-7.37 4.02-11.12 2.17-.91-.45-1.94.29-1.82 1.29l1.04 8.49c.05.38.29.71.63.88.79.39 1.36.97 1.73 1.76.12.25.32.47.57.62 14.31 8.39 23.93 14.3 28.86 17.71 4.01 2.79 5.61 6.41 4.82 10.86-1.64 9.09-1.49 11.18-9.82 16.39-4.5 2.82-14.67 1.78-19.89 1.37-6.12-.49-9.09 1.53-12.06 6.92-5.67 10.27-22.26 13.41-21.91 24.23.18 5.73 1.21 11.32.42 16.91-1.44 10.1-2.88 20.02-7.24 29.26-1.55 3.3-3.95 4.01-7.19 2.12a1.44 1.44 0 0 0-.93-.18c-5.84.77-13.1 5.88-18.06 9.06-3.76 2.41-6.93 3.74-9.52 4.01-3.45.34-8.36-3-8.95-6.61-.98-6.05-1.88-12.12-2.7-18.19-.05-.33-.24-.53-.57-.58-2.98-.49-7.2 2.86-9.33 4.77-5.13 4.6-10.51 8.74-16.14 12.41-.73.48-1.71.31-2.25-.38-2-2.61-2.09-5.57-1.39-8.95 1.81-8.72 3.67-17.83 8.12-25.68 3.73-6.59 6.88-11.6 9.47-15.03 1.91-2.53 2.14-5.03.7-7.5-.18-.31-.44-.53-.77-.67-4.33-1.78-13.13-.76-16.41-.54-3.16.21-3.91 1.88-5.58 4.09-2.98 3.95-6.68 9.55-11.04 12-4.96 2.77-9.89 5.61-14.79 8.52-9.76 5.79-19.03 13.14-28.43 19.98-4.33 3.15-7.36 6.07-10.34 10.08a3.239 3.239 0 0 1-3.95 1.02c-2.94-1.33-6.78-4.01-10.1-3.95-10.77.18-20.58 4.45-30.43 5.62-.81.1-1.54-.46-1.67-1.25-1.32-8.16 7.54-16.41 11.41-22.94.25-.43.14-.72-.33-.87l-.66-.21a.99.99 0 0 1-.66-.63c-.79-2.11-2.04-3.22-3.75-3.31-8.77-.49-17.26-2.07-26.02-2.67-4.17-.29-8.07-.73-11.7-1.32-3.87-.64-6.16-2.83-6.87-6.58-.06-.33.03-.61.26-.84 1.47-1.5 2.52-3.04 4.44-3.94 11.68-5.49 21.16-8.04 31.22-13.31 5.45-2.85 10.9-4.17 16.57-6.09 1.96-.67 3.34-1.46 4.14-2.38 4.45-5.12-4.24-9.21-6.6-12.55-7.31-10.35-10.2-21.15-12.79-33.34-.07-.33-.21-.61-.43-.86-.11-.13-.22-.27-.33-.41-.09-.13-.15-.28-.18-.45-1.23-8.36.5-16.99-4.76-24.08-4.44-5.99-7.17-9.88-8.2-11.69-2.68-4.74-5.81-12.59-9.4-23.56-.11-.33-.21-1.12-.31-2.38-.1-1.26-.92-2.04-1.17-3.15-1.33-5.74-2.7-10.82-2.98-16.96-.74-16.26-1.98-32.51-1.25-48.72 1-22.04 2.57-40.59 4.71-55.64 1.05-7.39 3.29-18.95 6.74-34.69 2.22-10.13 4.02-20.44 6.06-30.66.54-2.7-.15-5.38.15-7.97.57-5.07 1.77-14.05 3.6-26.95.43-3.01 1.9-5.41 4.43-7.2Z"
      style={{
        fill: "#a19ba5",
      }}
    />
    <path
      d="M264.87 150.54c-2.64 9.95-11.16 9.71-16.52 15.96l-.45-1.07c.95-1.45 1.7-2.38 2.25-2.79 4.42-3.34 8.99-9.53 14.72-12.1ZM357.57 192.17c1.2 4.16 2.92 8.24 5.17 12.23-2.8-2.19-5.87-3.4-9.22-3.65a.54.54 0 0 1-.49-.65l.93-4.37c.07-.34.24-.61.51-.82.71-.56 1.14-1.21 1.29-1.95.27-.48.87-.74 1.81-.79ZM203.33 224.53c-.09-.41-.27-.7-.52-.87-.45-.3-1.04-.23-1.42.15-4.07 4.08-7.49 8.47-10.26 13.17-1.49 2.54-4.93 5.39-4.95 8.85 0 1.21 1.1 2.13 2.29 1.91 2.81-.53 5.51-.52 8.08 0l-3.48 1.04c-.35.11-.68.27-.97.48-1.07.77-2.27 1.09-3.61.98-.2-.02-.4.06-.53.2-1.45 1.55-3.18 1.91-5.2 1.08-.24-.1-.4-.33-.4-.6v-6.14c0-.31.08-.59.23-.85a12.39 12.39 0 0 1 2.45-2.98c1.46-1.26 1.4-2.68 2.53-3.8 2.11-2.09 2.45-4.79 3.79-6.76 3.41-5.02 7.48-9.46 12.19-13.33 1.5-1.22 2.87-.92 4.43-2.37.89-.83 1.04-.71.47.35l-5.12 9.48ZM257.48 257.93l-5.53-.27c1.83-.65 3.67-.56 5.53.27ZM235.35 270.67c.63 1.31.48 2.73-.46 4.26-3.31-6.67-10.06-6.11-16.3-7.3 5.51-.28 11.09.73 16.76 3.04ZM259 287.43c-1.64 4.57-3.18 9.14-4.62 13.72-2.98 9.52-4.34 20.53-7.56 30.74-1.32 4.17-2.11 7.46-2.38 9.89-.72 6.58-.01 12.09-1.31 19.47l-.07-4.47.33-7.69c-.77-5.82-.03-12 2.22-18.53.77-6.58 1.92-13.07 3.46-19.48 1.17-4.87 4.49-8.58 5.25-13.36.61-3.87 2.17-7.3 4.68-10.29ZM244.07 381.21c.08.01.14.08.13.16l-.17 2.21c-.85 10.47-1.79 18.93-2.11 18.91h-.04c-.32-.03.11-8.54.95-19l.18-2.21c0-.09.08-.15.16-.14l.9.07ZM454.62 541.62c2.9 1.14 4.36 2.91 4.37 5.32l-4.37-5.32ZM460.06 559.22l1.51 10.18c2.16 3.31 5.15 5.14 8.98 5.49.31.03.6.13.85.32 1.07.78 2.17 1.5 3.32 2.17 2.77 1.61 4.59 3.28 7.08 5.01.22.15.36.39.39.66.18 1.55 1.03 2.55 2.56 3.01.29.09.52.27.68.52.29.46.74.84 1.34 1.13 4.81 2.34 8.21 6.01 6.38 11.77-.07.05-.22.04-.44-.02.58-4.3-1.15-6.68-4.8-9.1-5.53-3.65-10.65-7.04-15.61-11.48-2.46-2.2-5.35-3.73-8.68-4.59-.28-.07-.5-.23-.65-.48l-2.86-4.59a.574.574 0 0 1-.08-.29l.03-9.71ZM424.48 621.06c-2.55 1.2-5.12 1.91-7.72 2.13-4.77.26-14.76 1.65-18.93-.05-.5-.2-.63-.67-.38-1.41a5.94 5.94 0 0 1 3.05-.43c.01.08.01.16 0 .25-.01.15.07.24.22.25 7.78.54 15.7.29 23.76-.74ZM339.96 640.19c.39-.33.37-.64-.05-.91a.535.535 0 0 0-.37-.08c-7.73 1.03-15.6.87-23.59-.49 9.39-2.63 19.3-3.34 29.75-2.12.18.02.19.07.02.14l-3.48 1.55c-.23.11-.32.28-.29.52l.04.31c.05.35-.09.6-.41.75-.53.24-1.07.35-1.62.33ZM386.69 637.96l3.96.05c.33 0 .63.09.91.26 3.93 2.46 8.28.55 11.55 3.57.23.22.51.35.83.38 5.36.59 10.53.53 15.5-.2l9.27-2.8c.43-.13.87.14.96.58.25 1.2.3 1.97.17 2.3-5.23 2.75-10.38 3.4-15.47 1.96a.996.996 0 0 1-.65-.55c-.13-.27-.38-.41-.73-.44-3.68-.21-6.41-.13-10.22.96-5.36 1.53-10.86 2.07-16.49 1.63-.34-.03-.66.05-.95.23-2.77 1.7-4.61 4.09-5.52 7.16-.62 2.06-1.51 3.41-2.27 5.28-.11.27-.31.46-.59.57-.65.25-.88.69-.7 1.32.11.4 0 .72-.33.96-2.2 1.57-3.4 3.74-3.61 6.52-.03.35-.16.65-.39.91a28.617 28.617 0 0 0-5.18 8.16c-.28.66.57 1.21 1.06.69 4.7-5.01 7.9-8.92 15.28-12.03-6.96 4.4-12.27 10.11-17.98 15.76-.24.24-.36.19-.36-.15.01-3.9 1.04-7.16 3.1-9.78.87-1.11 1.28-2.2 1.25-3.27-.01-.33.04-.66.17-.97 4.21-10.41 10.82-18.36 16.48-27.85.29-.47.6-.88.95-1.21ZM261.54 659.52c.49-.09.92-.05 1.27.13.39.21.39.41 0 .61-.65.33-1.07.73-1.26 1.22v-1.96Z"
      style={{
        fill: "#a19ba5",
      }}
    />
    <path
      d="M205.7 258.49c9.42.74 18.94.68 28.25 1.87 2.49.32 5.2-.68 7.42-.64 3.51.07 7 .33 10.49.79 3.78.5 8.42.31 12.67 1.29 2.46 9.11-3.99 8.92-10.78 8.92-.98 0-2.95.58-5.9 1.74l-7.61-.78-1.8-.12c-1.22-.7-2.25-1-3.09-.89-5.67-2.31-11.25-3.32-16.76-3.04-1.79-.19-3.76-.67-5.89-1.42-2.43-.86-4.6 1.25-6.42.26.47-1.33.15-2.15-.97-2.46-1.71-.48-2.04-2.75-.54-3.69.22-.14.53-.75.93-1.83ZM270.99 261.19c.41-.29.9-.31 1.48-.06l6.77.08 5.67.18c.32 0 .56.16.73.43 1.25 2.11-.02 2.98-1.93 3.44-4.62 1.11-10.23 3.78-14.83 3.74-.34-.01-.63-.12-.88-.35-2.8-2.58 1-3.99 2.51-5.17a.68.68 0 0 0 .21-.81c-.35-.85-.26-1.35.27-1.48Z"
      style={{
        fill: "#020202",
      }}
    />
    <path
      d="m403.94 126.42-10.01 1.85c-11.39.35-22.62-1.48-33.69-5.48-9.43-3.4-14.46-13.59-4.81-20.82 6-4.49 12.38-7.84 19.87-6.86 13.34 1.74 23.58 1.5 35.42 9.16 12.65 8.19 4.02 19.39-6.78 22.15Zm-6.76-14.11c-3.27-4.34-25.8-4.39-30.82-3.99-1.08.09-1.53 1.43-.72 2.16 8.02 7.16 21.74 5.88 31.35 2.46.35-.13.41-.34.19-.63Z"
      style={{
        fill: "#1a0d20",
      }}
    />
  </svg>
    </SvgIcon>
  );
};
export default OgWassie;
